import React, { Component, useState } from 'react';
import Button from '@mui/material/Button';

import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import moment, { duration } from "moment";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Typography from '@mui/material/Typography';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';


// npm install @material-ui/core
/* Here is the documentation for the datepicker:
        https://reactdatepicker.com/#example-17
 */
import 'react-datepicker/dist/react-datepicker.css';

import Constants from "./Constants";
import './NewControlForm.css';
import Sortable from 'sortablejs';
import axios from "axios";
import Utils from "./Utils";
import SITLSearch from "./SITLSearch.js";
import { useEffect } from 'react';
import NEW_UI from './new_var_ui.json';
import Grid from '@mui/material/Grid';
import Tooltip from "@mui/material/Tooltip";
import SciencePaperSearch from "./SciencePaperSearch";



const EVENTS = require('./events.json');
const VARIABLES = require('./variables.json');
const DEFAULT_INCLUDE_DATES = require('./include_dates');
const initialFormStateConfig = require('./initial_form_state.json');


const options = Constants.SITL_SUGGEST;

// Initialize selectedDate from localStorage if available
let selectedDate = {
  displayTime: '2015-10-16 12:00',
  displayEndTime: '2015-10-16 14:00',
  date: new Date('Fri Oct 16 2015 05:00:00 GMT-0700 (Pacific Daylight Time)'),
  duration: 2
};

// Try to restore date/time from localStorage
try {
  const savedDataString = localStorage.getItem('savedVariablesData');
  if (savedDataString) {
    const savedData = JSON.parse(savedDataString);
    if (savedData.startTime) {
      selectedDate.date = new Date(savedData.startTime);
      selectedDate.displayTime = selectedDate.date.toISOString().slice(0, 16).replace('T', ' ');
      console.log('Restored date/time from localStorage at module load:', selectedDate.date);
    }
    if (savedData.duration !== undefined) {
      selectedDate.duration = savedData.duration;
      console.log('Restored duration from localStorage at module load:', selectedDate.duration);

      // Calculate and set displayEndTime
      const endDate = new Date(moment(selectedDate.date).add(selectedDate.duration, 'hours'));
      const endTime = (endDate.getUTCHours() < 10 ? '0' : '') + endDate.getUTCHours() + ':' + (endDate.getUTCMinutes() < 10 ? '0' : '') + endDate.getUTCMinutes();
      selectedDate.displayEndTime = (endDate.getUTCFullYear() + '-' +
        ((endDate.getUTCMonth() + 1) < 10 ? '0' : '') + (endDate.getUTCMonth() + 1) + '-' +
        (endDate.getUTCDate() < 10 ? '0' : '') + endDate.getUTCDate() + ' ' + endTime);
      console.log('Calculated displayEndTime:', selectedDate.displayEndTime);
    }
  }
} catch (e) {
  console.warn('Failed to restore date/time from localStorage at module load:', e);
}

let selectedVariables = {
  selectAllMult: false,
  selectAllSing: false
}

let displayVars = ["00", "01", "02", "03", "04", "05", "06", "07", "08", "0J"];

var sortedEle = null;

/**
 * Control form is a component that is embedded in the LandingPage and the ResultsScreen.
 * It navigates to 2 other pages but does so with callbacks (functteions) passed to it as props.
 * So as such it does not need to itself navigate anywhere. So that is why it remains in it's
 * original condition: class component.
 * It displays the criteria selection for the visualizer. Includes
 * fields such as spacecraft, start time, variables, etc.
 *
 * @prop onGenerateClick :: Callback function that accepts an object of form
 *                          state, called when the form is submitted. (Big Green Button)
 * @prop toNewMuiClick   :: Callback function that accepts an object of form
 *                          state, and sitl search data (when the sitl search query is selected)
 *                          (this functional component, replaces old sitl searchpage class component)
 * @prop defaults        :: (Optional) Default values for the form. Uses same
 */

const ControlFormNewVariables = (props) => {
  const [newList, setNewList] = useState([]);
  const [config, setConfig] = useState(NEW_UI);

  // Dynamic state based on configuration
  const [formState, setFormState] = useState(initialFormStateConfig);

  // State for selected variables order (for drag and drop)
  const [selectedVariablesOrder, setSelectedVariablesOrder] = useState([]);

  // State for saved variables order (for revert functionality)
  const [savedVariablesOrder, setSavedVariablesOrder] = useState([]);

  // State for saved variable selections (for revert functionality)
  const [savedVariableSelections, setSavedVariableSelections] = useState({});

  // State for drag and drop visual feedback
  const [draggedItem, setDraggedItem] = useState(null);
  const [dragOverItem, setDragOverItem] = useState(null);

  // State for accordion expansion
  const [expandedSections, setExpandedSections] = useState({});

  // State for constraint dependency tracking
  const [constraintDependencyMap, setConstraintDependencyMap] = useState({});
  const [idDependencyMap, setIdDependencyMap] = useState({});

  // State for standard plot selection
  const [standardPlotSelection, setStandardPlotSelection] = useState('');

  // Legacy state for backward compatibility
  const [state, setState] = useState({
    spacecraft: 1,
    duration: selectedDate.duration || props.defaults.duration || 2,
    event: "none",
    arrayorder: [],
    startTime: new Date(Constants.DEFAULT_START_TIME),
    endTime: "none",
    variables: [],
    preset: 'preset1',
    selectAll: false,
    selectAllMult: selectedVariables.selectAllMult ? true : false,
    selectAllSing: selectedVariables.selectAllSing ? true : false,
    onGenerateClick: null,
    fst: 0,
    bst: 1,
    gsm: 1,
    satisfied: []
  });

  // Initialize form state from configuration
  const initializeFormState = (config) => {
    const newFormState = {};
    console.log('Initializing form state from config:', config);
    const traverseConfig = (obj, path = '') => {
      if (obj.widgets) {
        obj.widgets.forEach(widget => {
          const fullPath = path ? `${widget.context}` : widget.context;
          if (widget.type === 'checkbox') {
            // No default selections - start with all checkboxes unchecked
            newFormState[fullPath] = false;
          } else if (widget.type === 'radio') {
            if (widget.default) {
              newFormState[fullPath] = true;
            } else {
              newFormState[fullPath] = false;
            }
          }
        });
      }

      // Recursively traverse nested objects
      Object.keys(obj).forEach(key => {
        if (typeof obj[key] === 'object' && obj[key] !== null && !Array.isArray(obj[key])) {
          const newPath = path ? `${key}` : key;
          traverseConfig(obj[key], newPath);
        }
      });
    };

    traverseConfig(config.form);
    return newFormState;
  };


  /**
   * recursive enough to find all of our nested widgets.
   * @param obj
   * @param targetValue
   * @param depth
   * @returns {{context}|*|null}
   */
  function findWidgetByContext(obj, targetValue, depth = 0) {
    // didn't find:
    if (typeof obj !== 'object' || obj === null || depth > 7) {
      return null;
    }

    // If you find the widget with your context
    if (depth <= 6 && obj.hasOwnProperty('context') && obj.context === targetValue) {
      return obj;
    }


    for (const key in obj) { // go down every key
      if (obj.hasOwnProperty(key)) {

        const result = findWidgetByContext(obj[key], targetValue, depth + 1);
        if (result) {
          return result; // If found in a nested object, return it immediately.
        }
      }
    }

    return null;
  }

  function framie(obj, targetValue, depth = 0) {
    // didn't dind:
    if (typeof obj !== 'object' || obj === null || depth > 7) {
      return null;
    }

    if (depth <= 6 && obj.hasOwnProperty('context') && obj.context === targetValue) {
      return obj; // this is the widget that has the context we want
    }

    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const result = findWidgetByContext(obj[key], targetValue, depth + 1);
        if (result) {
          console.log("going up with result", depth)
          return result; // If found in a nested object, return it immediately.
        }
      }
    }

    console.log("going back up with nothing")
    return null;
  }

  /* for presets */
  const findWidgetById = (config_form, targetId) => {
    if (config_form) {
      return obj.widgets.find(widget => widget.context === targetContext);
    }

    for (const key in obj) {
      if (typeof obj[key] === 'object' && obj[key] !== null) {
        const result = findWidgetByContext(obj[key], targetContext);
        if (result) return result;
      }
    }
    return null;
  };

  // Helper function to build constraint dependency map
  const buildConstraintDependencyMap = (config) => {
    const dependencyMap = {};

    const traverseConfig = (obj) => {
      if (obj.widgets) {
        obj.widgets.forEach(widget => {
          if (widget.transformers) {
            widget.transformers.forEach(transformer => {
              if (transformer.constraints) {
                transformer.constraints.forEach(constraint => {
                  if (!dependencyMap[constraint]) {
                    dependencyMap[constraint] = [];
                  }
                  dependencyMap[constraint].push(widget.context);
                });
              }
            });
          }
        });
      }

      // Recursively traverse nested objects
      Object.keys(obj).forEach(key => {
        if (typeof obj[key] === 'object' && obj[key] !== null && !Array.isArray(obj[key])) {
          traverseConfig(obj[key]);
        }
      });
    };

    traverseConfig(config.form);
    return dependencyMap;
  };

  // Helper function to get id(s) from context
  const getIdsFromContext = (config, context) => {
    const variableIds = [];
    const widgetConfig = findWidgetByContext(config.form, context);
    if (widgetConfig) {
      if (widgetConfig.transformers) {
        widgetConfig.transformers.forEach(transformer => {
          if (transformer.id && transformer.id !== "none" && transformer.id !== "TBD") {
            variableIds.push(transformer.id);
          }
        });
      }
    }
    return variableIds
  }

  // Helper function to build constraint dependency map
  const buildIdDependencyMap = (config) => {
    const dependencyMap = {};

    const traverseConfig = (obj) => {
      if (obj.widgets) {
        obj.widgets.forEach(widget => {
          if (widget.transformers) {
            widget.transformers.forEach(transformer => {
              if (Object.hasOwn(transformer, "id")) {
                const newMap = new Map();
                // Use field_name if available, otherwise display_name, otherwise widget.label
                let name = transformer.field_name || transformer.display_name || widget.label;
                // Replace {sc_num} template with actual spacecraft number
                const scNum = whichSpaceCraft()[0] || 1; // Get first spacecraft or default to 1
                name = name.replace(/{sc_num}/g, scNum);
                newMap.set("name", name);
                newMap.set("context", widget.context);
                // I didn't end up using this dict member but I think it's harmless and it may be useful
                // I ended up using constraintDependencyMap and creating sub maps of items that weren't in both arrays
                // see:
                // var gsm = constraintDependencyMap["custom_stack_plot.coordinates.gsm"];
                // var gse = constraintDependencyMap["custom_stack_plot.coordinates.gse"];
                //  const both = removeCommonElements(gse,gsm);
                newMap.set("cdf_data", transformer.cdf_data);
                if (transformer.constraints != undefined) {
                  let gse = transformer.constraints.filter(key => key.includes("coordinates.gse"))
                  let gsm = transformer.constraints.filter(key => key.includes("coordinates.gsm"))
                  if (gse.length > 0) {
                    if (newMap.get("cframe") == undefined) {
                      newMap.set("cframe", "gse");
                    } else {
                      newMap.set("cframe", "both");
                    }
                  } else {
                    if (gsm.length > 0) {
                      if (newMap.get("cframe") == undefined) {
                        newMap.set("cframe", "gsm");
                      } else {
                        newMap.set("cframe", "both");
                      }
                    }
                  }
                }
                dependencyMap[transformer.id] = newMap;
              }
            });

          }

        });
      }

      // Recursively traverse nested objects
      Object.keys(obj).forEach(key => {
        if (typeof obj[key] === 'object' && obj[key] !== null && !Array.isArray(obj[key])) {
          traverseConfig(obj[key]);
        }
      });
    };

    traverseConfig(config.form);
    return dependencyMap;
  };

  // Helper function to get all widgets that depend on a constraint
  const getDependentWidgets = (constraint, dependencyMap) => {
    return dependencyMap[constraint] || [];
  };

  /*
  Find contexts in formState that are checked/true and
   */
  function findCheckedVariables() {
    const keysWithValueTrue = Object.keys(formState).filter(key =>
      formState[key] === true)


    "particles.low_to_mid_spect.omnidirtional.ions"
    const widgetConfig = findWidgetByContext(config.form, selectedContext);

  }
  function reCheckExistingVars(value, selectedContext) {
    // the selected Widget's new value
    var configIsTrueItems = Object.keys(formState).filter(key => formState[key] === true);
    formState[selectedContext] = value;
    /* Now let's see if we need to remove any from the state.satisified (the list of vars that qualify to be plotted)
       1. get list of contexts with transfomers that are true in formState (these are the ones the user has selected and who may gain
       or lose elibility with the selection of the current widget/context)
       2. get each of it's constraints
       3. check each of those
       4. keep or remove the var from state.satisfied.
     */
    const newStuff = []; // = state.satisfied;

    // The new selection:
    if (value) {
      //const widgetConfig = findWidgetByContext(config.form, selectedContext);
      //if (widgetConfig.transformers) {
      configIsTrueItems.push(selectedContext);
      //}
    }
    else {
      configIsTrueItems = configIsTrueItems.filter(item => item !== selectedContext);

    }
    // The existing selections
    for (let myvarContext of configIsTrueItems) { // configIsTrueItems is every single context (including inside transformers
      /* this code will see if an selectedVariable is still qual
         not for every  formState-is-true[clicked] variable */
      const widgetConfig = findWidgetByContext(config.form, myvarContext);
      if (widgetConfig && widgetConfig.transformers && widgetConfig.transformers.length > 0) {
        /* check remaining constraints */
        if (widgetConfig.transformers.length > 1) {
          widgetConfig.transformers.forEach(transformer => {
            if (checkConstraints(transformer, myvarContext, value)) {
              //console.log("All constraints are still satisfied for this var (context of which is: " + transformer.panel + ")");
              if (!newStuff.includes(transformer.id)) {
                newStuff.push(transformer.id);
              } else {
                console.log("making newStuff new each time")
              }
            }
            // else id is not added
          });
        }
        else {
          if (checkConstraints(widgetConfig.transformers[0], myvarContext, value)) {
            //console.log("All constraints are still satisfied for this var (context of which is: " + myvarContext + ")");
            if (!newStuff.includes(widgetConfig.transformers[0].id)) {
              newStuff.push(widgetConfig.transformers[0].id);
            }
          } else {
            // console.log("Removing " + myvarContext + " from state.satisfied");
            if (newStuff.includes(widgetConfig.transformers[0].id)) {
              const index = newStuff.indexOf(widgetConfig.transformers[0].id);
              if (index !== -1) {
                newStuff.splice(index, 1); // Remove 1 element starting from 'index'
              }
            }
          }
        }
      }


    }
    return newStuff;
  }

  function checkConstraints(transformer, context) {
    let condition = true;
    let constraints = transformer.constraints;
    for (let i = 0; i < constraints.length; i++) {
      if (formState[constraints[i]] == undefined || formState[constraints[i]] == false) { // undefined allows us not to have to set up everything for defaults and maybe other cases
        condition = false;
      }
      //console.log(context,":", constraints[i], formState[constraints[i]]);
    }
    if (context != null && condition) {
      const newStuff = state.satisfied;
      if (!newStuff.includes(transformer.id)) {
        newStuff.push(transformer.id);
      }
      setState({ ...state, satisfied: newStuff });
    }
    return condition;
  }

  function removeCommonElements(arr1, arr2) {
    // Create new arrays containing only elements NOT present in the other array
    const newArr1 = arr1.filter(item => !arr2.includes(item));
    const newArr2 = arr2.filter(item => !arr1.includes(item));

    return { gse: newArr1, gsm: newArr2 };
  }
  const disableTheseWidgets = (value, disablers) => {

    var contexts = [];
    var gsm = constraintDependencyMap["custom_stack_plot.coordinates.gsm"];
    var gse = constraintDependencyMap["custom_stack_plot.coordinates.gse"];
    // We don't want to disable widgets that have transformers in both coordinates ( such as b-field)
    const both = removeCommonElements(gse, gsm);

    if (disablers[0].includes("bunch")) {
      if (disablers[0].includes("gse")) {
        contexts = both.gsm;
      }
      else if (disablers[0].includes("gsm")) {
        contexts = both.gse;
      }
    }
    else {
      contexts = disablers;
    }
    console.log("disablers:", disablers, contexts);

    contexts.forEach(context => {
      // Don't disable the coordinate radio buttons themselves - they should always be switchable
      if (context === "custom_stack_plot.coordinates.gse" || context === "custom_stack_plot.coordinates.gsm") {
        return;
      }

      const dependentWidget = document.getElementById(context);
      const dependentWidgetsLabel = document.getElementById(context + "_label");
      if (dependentWidget != null) {
        if (value) {
          if (dependentWidget.parentElement != null) {
            dependentWidget.parentElement.classList.add("new-control-form-widget-container-disabled");
          }
          if (dependentWidgetsLabel != null) {
            dependentWidgetsLabel.classList.add("new-control-form-widget-container-disabled");
          }
        } else {
          if (dependentWidget.parentElement != null) {
            dependentWidget.parentElement.classList.remove("new-control-form-widget-container-disabled");
          }
          if (dependentWidgetsLabel != null) {
            dependentWidgetsLabel.classList.remove("new-control-form-widget-container-disabled");
          }
        }
      }

      // } else {
      //   if (dependentWidget.parentElement != null) {
      //     dependentWidget.parentElement.classList.remove("new-control-form-widget-container-disabled");
      //   }
      //   dependentWidgetsLabel.classList.remove("new-control-form-widget-container-disabled");
      // }

    })
  }

  /**
   * This is to prevent the clicking of custom preset when FPI multi-sc is being used
   * This also gets called after a preset is selected and we want to add or subtract something.
   * In this case, then, we want to set it to Custom/preset99. In fact this gets called almost every
   * time a user touches the UI
   * @param context
   * @param value
   */
  const manageWidgetAndPreset = (context, value) => {

    if (!(localStorage.getItem('currentPreset') === 'preset12')) {
      localStorage.setItem('currentPreset', 'preset99');

    }
    handleWidgetChange(context, value);
  }

  // Handle widget state changes
  const handleWidgetChange = (context, value) => {
    console.log(`Widget changed: ${context} = ${value}`);
    var newStuff = [];
    setFormState(prev => {
      let newState = { ...prev, [context]: value };

      // --- Burst Checkbox || w/wo Burst Radio logic ---
      // Contexts
      const burstCheckbox = "custom_stack_plot.tracker.burst";
      const radioWithBurst = "custom_stack_plot.survey.with_burst";
      const radioNoBurst = "custom_stack_plot.survey.no_burst";

      // If Burst checkbox is checked, ensure w/ Burst radio is checked
      if (context === burstCheckbox && value === true) {
        newState[radioWithBurst] = true;
        newState[radioNoBurst] = false;
      }
      // If w/o Burst radio is checked, uncheck Burst checkbox
      if (context === radioNoBurst && value === true) {
        newState[burstCheckbox] = false;
        newState[radioWithBurst] = false;
      }
      // If w/ Burst radio is checked, automatically check Burst checkbox
      if (context === radioWithBurst && value === true) {
        newState[radioNoBurst] = false;
        newState[burstCheckbox] = true;
      }

      // Process constraints if this widget has them
      if (config && config.form) {
        const widgetConfig = findWidgetByContext(config.form, context);
        if (widgetConfig && widgetConfig.hasOwnProperty('disablers')) {
          disableTheseWidgets(value, widgetConfig.disablers);
        }
        if (widgetConfig && widgetConfig.transformers) {
          console.log(`Found ${widgetConfig.transformers.length} transformers for widget: ${context}`);
          widgetConfig.transformers.forEach(transformer => {
            console.log(`Processing transformer: ${transformer.name}`);
            if (transformer.constraints) {
              console.log(`Found ${transformer.constraints.length} constraints:`, transformer.constraints);
              if (value == true && checkConstraints(transformer, context)) {
                transformer.constraints.forEach(constraint => {
                  // Validate constraint exists before applying
                  const constraintWidget = findWidgetByContext(config.form, constraint);
                  if (constraintWidget) {
                    if (value) {
                      // If this widget is being checked, automatically check its constraints
                      console.log(`Auto-checking constraint: ${constraint} for widget: ${context}`);
                      newState[constraint] = true;
                    } else {
                      // If this widget is being unchecked, check if other widgets still depend on this constraint
                      const dependentWidgets = getDependentWidgets(constraint, constraintDependencyMap);
                      const stillDependedOn = dependentWidgets.some(depWidget =>
                        depWidget !== context && newState[depWidget]
                      );
                      if (!stillDependedOn) {
                        console.log(`Auto-unchecking constraint: ${constraint} for widget: ${context} (no other dependencies)`);
                        newState[constraint] = false;
                      } else {
                        console.log(`Keeping constraint: ${constraint} checked (still depended on by other widgets)`);
                      }
                    }
                  } else {
                    console.warn(`Constraint widget not found: ${constraint} for widget: ${context}`);
                  }
                });
              } else {
                console.log(`No constraints found for transformer: ${transformer.name}`);
              }
            }
            else {
              console.log(`All of the constrainsts are not satisfied for: ${context}`);
              newStuff.push(context);
            }
          });
        } else {
          console.log(`No transformers found for widget: ${context}`);
        }
      } else {
        console.log(`Config not loaded yet for widget: ${context}`);
      }

      return newState;
    });
    newStuff.push(...reCheckExistingVars(value, context));
    setState({ ...state, satisfied: newStuff });
    console.log("current state.satisfied:", state.satisfied);
  };

  const whichSpaceCraft = () => {
    const activeSC = Object.keys(formState).filter(key => (formState[key] === true && key.includes("mms")));
    const scids = [];
    for (let scid of activeSC) {
      scids.push(parseInt(scid.slice(-1)));
    }
    //const activeScIds = activeSC.forEach(key => {parseInt(key.slice(-1))})
    //console.log("activeSC", scids);
    return scids;
  }
  const selectFastOnly = () => {
    const activeSC = Object.keys(formState).filter(key => (formState[key] === true && key.includes("with_burst")));
    return activeSC.length > 0 ? 0 : 1
  }
  // Process form state to extract selected variables and transformers
  const processFormState = () => {
    const selectedVariables = [];
    const selectedTransformers = [];
    const variableIds = []; // Add this to collect the actual variable IDs

    // Check if we have saved data in localStorage that should be used
    const savedDataString = localStorage.getItem('savedVariablesData');
    let savedData = null;
    if (savedDataString) {
      try {
        savedData = JSON.parse(savedDataString);
        console.log('processFormState: Found saved data in localStorage:', savedData);
      } catch (e) {
        console.log('processFormState: Error parsing saved data:', e);
      }
    }

    // Use saved selections if available, otherwise use current form state
    const stateToProcess = savedData && savedData.selections ? savedData.selections : formState;
    console.log('processFormState: Using state:', stateToProcess);

    // Traverse form state to find selected widgets
    Object.keys(stateToProcess).forEach(context => {
      if (stateToProcess[context]) {
        // Find the widget configuration for this context
        if (config && config.form) {
          const widgetConfig = findWidgetByContext(config.form, context);
          if (widgetConfig) {
            // Handle widgets with transformers (actual plot variables)
            if (widgetConfig.transformers) {
              widgetConfig.transformers.forEach(transformer => {
                if (transformer.id && transformer.id !== "none" && transformer.id !== "TBD") {
                  selectedTransformers.push({
                    id: transformer.id,
                    name: transformer.name,
                    panel: transformer.panel,
                    constraints: transformer.constraints || []
                  });
                  // Add the variable ID to our list for the backend
                  variableIds.push(transformer.id);
                }
              });
            }
            // Handle coordinate widgets (include in backend but not display)
            else if (context.includes('coordinates')) {
              console.log(`Coordinate selection: ${context} = ${stateToProcess[context]}`);
              // Include coordinate context in variableIds for backend processing
              variableIds.push(context);
            }
            // Handle other widgets without transformers (configuration options)
            else if (widgetConfig.value) {
              console.log(`Widget ${context} has value: ${widgetConfig.value}`);
              // These are configuration widgets, not plot variables
            }
          }
        }
        // Only add to selectedVariables if it's not a coordinate (for display purposes)

      }
    });

    console.log('processFormState: Final variableIds:', variableIds);
    return { selectedVariables, selectedTransformers, variableIds };
  };

  function arraysEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) {
      return false;
    }
    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) {
        return false;
      }
    }
    return true;
  }
  // reorder a list of ids (variables or satisfied) given a list of contexts (selectedVariablesOrder)
  // key is that every Id is in a widget
  function selectUsingGutsOfRenderNewControlForm() {
    const selectedVars = getSelectedVariablesForDisplay();
    var empty_ids = [];
    if (selectedVars) {
      const empty = selectedVars.filter(item => item.variableIds.length > 0);
      var empty_ids = changeBaseFromContextToIdsForSeparateItemsInSelectedVariablesPane(empty);
      console.log("presets empty-reorder", empty_ids);
    }
    /*
    Earlier I couldn't resist trying to start our multi-spacecraft utility. However now that Ephemeris is always added I ran into a problem
    template_args on the backend resolves which spacecraft is being used and so which data to download. However early on in the backend
    processing I change a single length spacecraft array into a scalar...for nominal processing. However if I leave it as an array for multi-spacecraft
    use I haven't yet enable ephemeris to work with an array of spacecraft (use MMS1). multi-spacecraft are unique in that they ID all of there data
    as MMS1, MMS2 etc and don't use template_args {sc_num} as all the other data do.
     */
    var n_spacecraft = whichSpaceCraft();
    if (n_spacecraft.length == 1 && !empty_ids.includes('10')) {
      if (formState["custom_stack_plot.coordinates.gse"] == false && formState["custom_stack_plot.coordinates.gsm"]) {
        empty_ids.push("0J");
      } else {
        empty_ids.push("0K");
      }
    }
    return empty_ids;


  }
  // Get selected variables with their labels for display
  const getSelectedVariablesForDisplay = () => {
    const selectedVariables = [];

    // Check if we have saved data in localStorage that should be used
    const savedDataString = localStorage.getItem('savedVariablesData');
    let savedData = null;
    if (savedDataString) {
      try {
        savedData = JSON.parse(savedDataString);
      } catch (e) {
        console.log('getSelectedVariablesForDisplay: Error parsing saved data:', e);
      }
    }

    // Use saved selections if available, otherwise use current form state
    const stateToProcess = savedData && savedData.selections ? savedData.selections : formState;

    Object.keys(stateToProcess).forEach(context => {
      if (stateToProcess[context]) {
        // Skip coordinate widgets for display purposes


        // Find the widget configuration for this context
        if (config && config.form) {
          const widgetConfig = findWidgetByContext(config.form, context);
          if (widgetConfig) {
            // Get the variable IDs from transformers
            const variableIds = [];
            if (widgetConfig.transformers) {
              widgetConfig.transformers.forEach(transformer => {
                if (transformer.id && transformer.id !== "none" && transformer.id !== "TBD") {
                  variableIds.push(transformer.id);
                }
              });
            }

            selectedVariables.push({
              context: context,
              label: widgetConfig.label,
              section: context.split('.')[0], // Get the section name from context
              variableIds: variableIds // Add the variable IDs for display
            });
          }
        }
      }
    });

    // These next two blocks of code allow only ids that are stored in state.satisfied to be shown in Selected Variables column
    // If we have a custom order, use it; otherwise return the default order

    if (selectedVariablesOrder.length > 0) {
      const orderedVariables = [];
      for (const id of selectedVariablesOrder) {
        if (idDependencyMap[id] !== undefined) {
          const context = idDependencyMap[id].get('context'); /* we still have our context/id dilemma */
          const foundVariable = selectedVariables.find(v => v.context === context);
          if (foundVariable && foundVariable.variableIds.length > 0) {
            if (foundVariable.variableIds.length > 1) {
              const orglength = foundVariable.variableIds.length;
              const temp = { ...foundVariable.variableIds };
              for (let i = 0; i < Object.keys(temp).length; i++) {
                let id = temp[i];
                if (!state.satisfied.includes(id)) {
                  const index = foundVariable.variableIds.indexOf(id); // Find the index of the value
                  if (index !== -1) { // Check if the value exists in the array
                    foundVariable.variableIds.splice(index, 1); // Remove 1 element starting from the found index
                  }
                }
              }
              if (foundVariable.variableIds.length > 0) { // if at least one of the transformer ids is there
                orderedVariables.push(foundVariable);
              }
            } else {
              if (state.satisfied.includes(foundVariable.variableIds[0])) {
                orderedVariables.push(foundVariable);
              }
            }
          }
        }
      }



      // Add any new variables that aren't in the order yet
      const newVariables = [];
      var uniq = [];
      for (const v of selectedVariables) {
        const thisIds = getIdsFromContext(config, v.context);

        thisIds.forEach((thisId) => {

          // a context with multiple ids:
          if (!selectedVariablesOrder.includes(thisId) && v.variableIds.length > 0) {
            if (!state.satisfied.includes(thisId)) {
              const index = v.variableIds.indexOf(thisId); // Find the index of the value
              if (index !== -1) { // Check if the value exists in the array
                v.variableIds.splice(index, 1); // Remove 1 element starting from the found index
              }
            }
            if (v.variableIds.length > 0 && !orderedVariables.includes(v)) { // if at least one of the transformer ids is there
              if (!uniq.includes(thisId)) {
                orderedVariables.push(v);     // we may have repeated contexts with unique ids
              }
            }
          } else {  // contexts with only one id are simpler
            if (state.satisfied.includes(thisId) && (!newVariables.includes(thisId) || !orderedVariables.includes(thisId))) {
              //newVariables.push(v);
            }
          }
          uniq.push(thisId);
        });
      }

      return [...orderedVariables, ...newVariables];
    }

    return selectedVariables;
  };

  // Drag and drop handlers for selected variables
  const handleSelectedVarDragStart = (event, context) => {
    event.dataTransfer.setData("text/plain", context);
    event.dataTransfer.effectAllowed = "move";
    setDraggedItem(context);
  };

  const handleSelectedVarDragOver = (event, targetContext) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = "move";
    setDragOverItem(targetContext);
  };

  const handleSelectedVarDragLeave = (event) => {
    // Only clear drag over if we're leaving the item entirely
    if (!event.currentTarget.contains(event.relatedTarget)) {
      setDragOverItem(null);
    }
  };

  const handleSelectedVarDrop = (event, targetContext) => {
    console.log("start of handleSelectedVarDrop");
    event.preventDefault();
    const draggedContext = event.dataTransfer.getData("text/plain");

    setDraggedItem(null);
    setDragOverItem(null);

    console.log("drag context vs target context ", draggedContext, " == ", targetContext);
    if (draggedContext === targetContext) return;
    console.log("Current selected length: ", selectedVariablesOrder.length)

    /* const currentOrder = selectedVariablesOrder.length > 0 ?
      selectedVariablesOrder : 
      getSelectedVariablesForDisplay().map(v => v.context);
      Note: contents of selectedVariables has changed a lot
    */
    const currentOrderPrep = getSelectedVariablesForDisplay();
    const empty = currentOrderPrep.filter(item => item.variableIds.length > 0);
    const currentOrder = changeBaseFromContextToIdsForSeparateItemsInSelectedVariablesPane(empty);
    //const currentOrder = currentOrderPrep.filter(item => item.variableIds.length > 0);
    console.log("Contents of current order", currentOrder);
    const draggedIndex = currentOrder.indexOf(draggedContext);
    const targetIndex = currentOrder.indexOf(targetContext);

    console.log("drag index vs target index -1? ", draggedIndex, targetIndex);
    if (draggedIndex === -1 || targetIndex === -1) return;

    // Create new order by moving the dragged item
    const newOrder = [...currentOrder];
    newOrder.splice(draggedIndex, 1);
    newOrder.splice(targetIndex, 0, draggedContext);
    console.log("Contents of new order", newOrder);
    console.log("end of handleSelectedVarDrop");


    const newStuff = [...state.satisfied]
    let temp = state.satisfied[draggedIndex];
    newStuff.splice(draggedIndex, 1);
    newStuff.splice(targetIndex, 0, temp);
    setState({ ...state, satisfied: newStuff });
    setSelectedVariablesOrder(newOrder);
    console.log("Contents of new satisfied", state.satisfied, newStuff);


  };

  const handleSelectedVarDragEnd = () => {
    setDraggedItem(null);
    setDragOverItem(null);
  };

  // Save current variables order and selections to localStorage and state
  const saveVariablesOrder = () => {
    console.log('=== MANUAL SAVE TRIGGERED (Generate Plots) ===');
    localStorage.setItem('prev', localStorage.getItem('savedVariablesData'));

    const currentOrder = selectedVariablesOrder.length > 0 ?
      selectedVariablesOrder :
      getSelectedVariablesForDisplay().map(v => v.context);

    // Save the current form state (which includes all selections)
    const currentSelections = { ...formState };

    console.log('Current order to save:', currentOrder);
    console.log('Current selections to save:', currentSelections);

    setSavedVariablesOrder(currentOrder);
    setSavedVariableSelections(currentSelections);

    // Save both to localStorage, including date/time information
    const savedData = {
      order: currentOrder,
      selections: currentSelections,
      ids: state.satisfied,
      startTime: selectedDate.date.toISOString(),
      duration: state.duration
    };

    console.log('Saving complete data to localStorage:', savedData);
    localStorage.setItem('savedVariablesData', JSON.stringify(savedData));


  };


  // Restore saved variables order and selections from localStorage and state
  const restoreVariablesOrder = () => {
    // Try to get from state first, then from localStorage
    let savedData;

    if (savedVariablesOrder.length > 0 && Object.keys(savedVariableSelections).length > 0) {
      savedData = {
        order: savedVariablesOrder,
        selections: savedVariableSelections,
        ids: state.satisfied
      };
    } else {
      savedData = JSON.parse(localStorage.getItem('savedVariablesData') || '{"order": [], "selections": {}, "ids": []}');
    }

    // Essentially this is a preset so whatever we did for the presets we need to do here.
    if (savedData.order.length > 0) {
      setSelectedVariablesOrder(savedData.order);
      const savedDataString = localStorage.getItem('prev');
      if (savedDataString) {
        const savedData = JSON.parse(savedDataString);
        ReturnToPreviousLikeAPreset(savedData.ids);
      }
      console.log('Restored variables order:', savedData.order);

    }

    if (Object.keys(savedData.selections).length > 0) {
      setFormState(savedData.selections);
      console.log('Restored variable selections:', savedData.selections);
    }
  };

  const initSatisfaction = () => {
    // Build satisfy constraints map
    var newStuff = [];
    newStuff.push(...reCheckExistingVars(false, null));
    setState({ ...state, satisfied: newStuff });

  }
  // Function to validate and clean up orphaned constraints
  const validateAndCleanupConstraints = () => {
    setFormState(prev => {
      const newState = { ...prev };
      let hasChanges = false;

      // Check each checked widget to see if it's a valid constraint
      Object.keys(newState).forEach(context => {
        if (newState[context]) {
          const widgetConfig = findWidgetByContext(config.form, context);
          if (!widgetConfig) {
            console.warn(`Removing orphaned constraint: ${context}`);
            newState[context] = false;
            hasChanges = true;
          } else {
            // Check if this constraint is still needed by any checked widgets
            const dependentWidgets = getDependentWidgets(context, constraintDependencyMap);
            const stillNeeded = dependentWidgets.some(depWidget => newState[depWidget]);

            if (!stillNeeded) {
              //console.log(`Removing unused constraint: ${context}`);
              newState[context] = false;
              hasChanges = true;
            }
          }
        }
      });

      return hasChanges ? newState : prev;
    });
  };

  // Render widgets based on configuration
  const renderWidgets = (widgets, sectionPath) => {
    if (sectionPath.includes("superfluous")) {
      if (widgets.length > 1) {
        if (formState['custom_stack_plot.coordinates.gse'] == true) {
          widgets = widgets.filter(item => item.context === "custom_stack_plot.ephemeris.gse");

        } else if (formState['custom_stack_plot.coordinates.gsm'] == true) {
          widgets = widgets.filter(item => item.context === "custom_stack_plot.ephemeris.gsm")
        } else {
          return null; /* offer no ephemeris */
        }
      }
    }
    return widgets.map((widget, index) => {
      const context = widget.context;
      const isChecked = formState[context] || false;
      var tempType = widget.type
      if (localStorage.getItem("currentPreset") === "preset12" && sectionPath.includes("custom_stack_plot.spacecraft")) {
        tempType = "checkbox";
      }
      if (tempType === 'checkbox') {
        /*console.log('Creating checkbox:', {
          label: widget.html_label || widget.label,
          context: context,
          sectionPath: sectionPath,
          checked: isChecked,
          disabled: widget.disabled
        }); */
        const widgetLabel = (widget.label || widget.html_label).replace(/\s+/g, '-').toLowerCase();
        const wrapperClassName = `${sectionPath.replace(/\./g, '-')}-${widgetLabel}`;
        const checkboxElement = (
          <div className={wrapperClassName}>
            <FormControlLabel
              key={`${sectionPath}-${index}`}

              control={
                <Checkbox
                  color="default"
                  id={context}
                  checked={isChecked}
                  onChange={(e) => manageWidgetAndPreset(context, e.target.checked)}
                  disabled={widget.disabled}
                  size="small"
                  className={widget.color === 'lightgrey' ? 'new-control-form-checkbox-color-lightgrey' : 'new-control-form-checkbox-color-default'}
                />
              }
              label={widget.html_label} id={context + "_label"}
              className={`new-control-form-widget-container ${widget.color === 'lightgrey' ? 'new-control-form-widget-container-disabled' : ''} ${widget.disabled ? 'new-control-form-widget-container-opacity' : ''}`}
              style={{ marginRight: '8px', marginBottom: '0' }} // Add horizontal spacing
            />
          </div>
        );

        // Wrap with tooltip if tooltip text is provided
        if (widget.tooltip) {
          return (
            <Tooltip title={widget.tooltip} placement="top" arrow>
              {checkboxElement}
            </Tooltip>
          );
        }

        return checkboxElement;
      } else if (tempType === 'radio') {
        const widgetLabel = (widget.label || widget.html_label || '').replace(/\s+/g, '-').toLowerCase();
        const wrapperClassName = `${sectionPath.replace(/\./g, '-')}-${widgetLabel}`;

        const radioElement = (
          <div key={`${sectionPath}-${index}`} className={wrapperClassName}>
            <FormControlLabel
              color="default"
              value={context}
              id={context}
              control={
                <Radio
                  color="default"
                  checked={isChecked}
                  onChange={(e) => handleWidgetChange(context, e.target.checked)}
                  disabled={widget.disabled}
                  size="small"
                  className={widget.color === 'lightgrey' ? 'new-control-form-radio-color-lightgrey' : 'new-control-form-radio-color-default'}
                />
              }
              label={widget.html_label}
              className={`new-control-form-widget-container ${widget.color === 'lightgrey' ? 'new-control-form-widget-container-disabled' : ''} ${widget.disabled ? 'new-control-form-widget-container-opacity' : ''}`}
              style={{ marginRight: '8px', marginBottom: '0' }} // Add horizontal spacing
            />
          </div>
        );

        // Wrap with tooltip if tooltip text is provided
        if (widget.tooltip) {
          return (
            <Tooltip title={widget.tooltip} placement="top" arrow>
              {radioElement}
            </Tooltip>
          );
        }

        return radioElement;
      }
      return null;
    });
  };

  // Recursive function to render nested subsections with unlimited depth
  const renderNestedSubsections = (subsection, sectionPath, depth = 0) => {

    if (!subsection || typeof subsection !== 'object') return null;

    // Get all nested sections (excluding 'title' and 'widgets')
    const nestedSections = Object.keys(subsection).filter(key =>
      key !== 'title' &&
      typeof subsection[key] === 'object' &&
      subsection[key] !== null
    );

    // Check if we have any content to render
    const hasWidgets = subsection.widgets && subsection.widgets.length > 0;
    const hasNestedSections = nestedSections.length > 0;

    // If no content, return null
    if (!hasWidgets && !hasNestedSections) return null;

    const content = [];

    // Render widgets if they exist
    if (hasWidgets) {
      var hasGroupedWidgets = subsection.widgets.some(w => w.group);
      // preset12 is  Multi-SC FPI which toggles checkboxes and radio buttons
      if (localStorage.getItem("currentPreset") === "preset12" && subsection.title == "Spacecraft") {
        hasGroupedWidgets = false
      }
      if (hasGroupedWidgets) {
        content.push(
          <RadioGroup
            name={`${sectionPath}-radio-group`}
            value={subsection.widgets.find(w => formState[w.context])?.context || ''}
            onChange={(e) => {
              subsection.widgets.forEach(widget => {
                handleWidgetChange(widget.context, widget.context === e.target.value);
              });
            }}
            row
            className={`nested-radio-group depth-${depth}`}
          >
            {renderWidgets(subsection.widgets, sectionPath)}
          </RadioGroup>
        );
      } else {
        content.push(
          <div key={`${sectionPath}-widgets`} className={`nested-widgets-container depth-${depth}`}>
            {renderWidgets(subsection.widgets, sectionPath)}
          </div>
        );
      }
    }

    // Render nested subsections recursively
    nestedSections.forEach(nestedKey => {
      const nestedSubsection = subsection[nestedKey];
      const nestedPath = `${sectionPath}.${nestedKey}`;
      const nestedContent = renderNestedSubsections(nestedSubsection, nestedPath, depth + 1);

      if (nestedContent) {
        content.push(
          <div key={nestedKey} className={`nested-subsection depth-${depth}`}>
            {nestedSubsection.title && (
              <Typography
                variant={depth === 0 ? "subtitle1" : depth === 1 ? "subtitle2" : "body2"}
                className={`nested-subsection-title depth-${depth}`}
              >
                {nestedSubsection.title}:
              </Typography>
            )}
            <div className={`nested-subsection-content depth-${depth}`}>
              {nestedContent}
            </div>
          </div>
        );
      }
    });

    // Only return a container if we have content
    if (content.length === 0) return null;

    // If only one item and it's a direct widget (no nested subsections), return it directly
    if (content.length === 1 && hasWidgets && !hasNestedSections) {
      return content[0];
    }

    // Otherwise, wrap in container
    return (
      <div key={`${sectionPath}-container`} className={`nested-subsections-container depth-${depth}`}>
        {content}
      </div>
    );
  };

  // Render a section with accordion
  const renderSection = (sectionKey, sectionConfig) => {
    // Special handling for ancillary variables (custom_stack_plot)
    if (sectionKey === 'custom_stack_plot') {
      return (
        <div key={sectionKey} className="new-control-form-section-wrapper">
          <Typography variant="h6" className="new-control-form-section-title">
            {sectionConfig.title}
          </Typography>
          {(() => {
            const keys = Object.keys(sectionConfig).filter(key => key !== 'title' && key !== 'widgets');
            const processedKeys = new Set();

            return keys.map(key => {
              // Skip if already processed
              if (processedKeys.has(key)) return null;

              const subsection = sectionConfig[key];

              // Handle survey/trackers combination
              if (key === 'survey' || key === 'trackers') {
                const surveySubsection = sectionConfig.survey;
                const trackersSubsection = sectionConfig.trackers;

                // Mark both as processed
                processedKeys.add('survey');
                processedKeys.add('trackers');

                // Only render if at least one exists
                if (!surveySubsection && !trackersSubsection) return null;

                return (
                  <div key="survey-trackers-combined" className="ancillary-variable-combined-row">
                    {/* Survey section */}
                    {surveySubsection && surveySubsection.widgets && (
                      <div className="ancillary-variable-section">
                        <Typography variant="subtitle1" className="ancillary-variable-label">
                          Survey:
                        </Typography>
                        <div className={`${sectionKey}_survey ancillary-variable-options `}>
                          {renderNestedSubsections(surveySubsection, `${sectionKey}.survey`, 0)}
                        </div>
                      </div>
                    )}

                    {/* Trackers section */}
                    {trackersSubsection && trackersSubsection.widgets && (
                      <div className="ancillary-variable-section">
                        <Typography variant="subtitle1" className="ancillary-variable-label">
                          Trackers:
                        </Typography>
                        <div className="ancillary-variable-options">
                          {renderNestedSubsections(trackersSubsection, `${sectionKey}.trackers`, 0)}
                        </div>
                      </div>
                    )}
                  </div>
                );
              }

              // Mark as processed and render normally
              processedKeys.add(key);
              return (
                <div key={key} className="ancillary-variable-row">
                  <Typography variant="subtitle1" className="ancillary-variable-label">
                    {subsection.title}:
                  </Typography>
                  <div className="ancillary-variable-options">
                    {renderNestedSubsections(subsection, `${sectionKey}.${key}`, 0)}
                  </div>
                </div>
              );
            });
          })()}
        </div>
      );
    }

    // Original renderSection logic for other sections
    return (
      <div key={sectionKey} className="new-control-form-section-wrapper">
        <hr className="var-divider"></hr>
        <Typography variant="h6" className="new-control-form-section-title">
          {sectionConfig.title}
        </Typography>
        {Object.keys(sectionConfig).map(key => {
          const subsection = sectionConfig[key];
          if (key === 'title' || key === 'widgets') return null;

          // Check if this subsection should have accordion behavior
          const shouldUseAccordion = (sectionKey === 'particles' || sectionKey === 'em_fields') &&
            (key === 'low_to_mid_spect' || key === 'low_to_mid_moments' || key === 'high_energy_particle_spect' ||
              key === 'b_field' || key === 'e_field');

          if (shouldUseAccordion) {
            const isExpanded = expandedSections[`${sectionKey}.${key}`] || false;
            return (
              <Accordion
                key={key}
                expanded={isExpanded}
                onChange={() => setExpandedSections(prev => ({
                  ...prev,
                  [`${sectionKey}.${key}`]: !isExpanded
                }))}
                className={"new-control-form-accordion " + key}
              >
                <AccordionSummary expandIcon={<ArrowDropDownIcon className='var_arrows' />}>
                  <Typography variant="subtitle1">{subsection.title || key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}</Typography>
                </AccordionSummary>
                <AccordionDetails className="new-control-form-accordion-details">
                  {renderNestedSubsections(subsection, `${sectionKey}.${key}`, 0)}
                </AccordionDetails>
              </Accordion>
            );
          } else {
            // Regular subsection without accordion - use recursive rendering
            return (
              <div key={key} className="new-control-form-subsection-container">
                <Typography variant="subtitle1" className="new-control-form-subsection-title">
                  {subsection.title || key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}
                </Typography>
                {renderNestedSubsections(subsection, `${sectionKey}.${key}`, 0)}
              </div>
            );
          }
        })}
      </div>
    );
  };

  // Render all sections from configuration
  const renderAllSections = () => {
    if (!config || !config.form) {
      console.log('Config not loaded yet:', config);
      return <div>Loading configuration...</div>;
    }

    try {
      return Object.keys(config.form).map(sectionKey => {
        const sectionConfig = config.form[sectionKey];
        if (!sectionConfig || !sectionConfig.title) {
          console.warn(`Invalid section config for ${sectionKey}:`);
          return null;
        }

        return (
          <div key={sectionKey} className="new-control-form-section-wrapper">
            {renderSection(sectionKey, sectionConfig)}
          </div>

        );
      }).filter(Boolean); // Remove null entries
    } catch (error) {
      console.error('Error rendering sections:', error);
      return <div>Error loading configuration</div>;
    }
  };

  /*
  For EIS omni we want to disable Higher-Energy for
      electrons, He+, O+ when the checkboxes are clicked.
      for H+, we want to enable Higher-Energy (It has 2 transformers, one for both)
   */
  function handleStandardPlotChange(value) {
    //const value = event.target.value;
    console.log("preset value:", value);

    initializeFormState(NEW_UI);
    setDefaultStorage();
    initSatisfaction();

    // Check if preset supports burst mode (skip for Default, Select None, and Custom presets)
    let presetSupportsBurst = false;
    const skipBurstCheck = value === "preset1" || value === "preset0" || value === "preset99";
    const presetVariableIds = VARIABLES.presets.filter(item => item.id == value)[0].variableIds;

    if (!skipBurstCheck) {
      presetVariableIds.forEach(transformer_id => {
        if (idDependencyMap[transformer_id] != undefined) {
          const context = idDependencyMap[transformer_id].get('context');
          const widgetConfig = findWidgetByContext(config.form, context);
          if (widgetConfig && widgetConfig.transformers) {
            widgetConfig.transformers.forEach(transformer => {
              if (transformer.id === transformer_id && transformer.constraints) {
                transformer.constraints.forEach(constraint => {
                  if (constraint === "custom_stack_plot.survey.with_burst") {
                    presetSupportsBurst = true;
                  }
                });
              }
            });
          }
        }
      });
    }

    (presetVariableIds).forEach(transformer_id => {
      // 1. get context from preset id
      // 0K and 0J, our GSM and GSE variables are no longer added to Selected Variable list but always shown and so they are handled on the backend
      if (idDependencyMap[transformer_id] == undefined) {
        return;
      }
      const context = idDependencyMap[transformer_id].get('context');
      var newState = formState;
      // 2. set all the id's constraints to true
      const widgetConfig = findWidgetByContext(config.form, context);
      if (widgetConfig && widgetConfig.transformers) {
        console.log(`Found ${widgetConfig.transformers.length} transformers for widget: ${context}`);
        widgetConfig.transformers.forEach(transformer => {


          if (transformer.id === transformer_id) {
            transformer.constraints.forEach(constraint => {
              // since we have magnetic field for both gsm and gse, we want the system to decide which one to use
              if (!(constraint == "custom_stack_plot.coordinates.gse" ||
                constraint == "custom_stack_plot.coordinates.gsm")) {
                newState[constraint] = true;
                console.log("Setting constraint", constraint, " to true");
              }
            });
          }
        });
      }

      setState({ formState: newState });
      // since we have magnetic field for both gsm and gse, we want the system to decide which one to use
      if (!(idDependencyMap[transformer_id].get('context') == "custom_stack_plot.coordinates.gse" ||
        idDependencyMap[transformer_id].get('context') == "custom_stack_plot.coordinates.gsm")) {
        handleWidgetChange(idDependencyMap[transformer_id].get('context'), true);
      }

    })

    // If preset doesn't support burst, turn off burst mode (only for non-special presets)
    if (!skipBurstCheck && !presetSupportsBurst) {
      const burstCheckbox = "custom_stack_plot.tracker.burst";
      const radioWithBurst = "custom_stack_plot.survey.with_burst";
      const radioNoBurst = "custom_stack_plot.survey.no_burst";

      var newState = formState;
      newState[burstCheckbox] = false;
      newState[radioWithBurst] = false;
      newState[radioNoBurst] = true;
      setState({ formState: newState });

      console.log("Preset does not support burst - disabling burst mode");
    }

    localStorage.setItem('currentPreset', value);
  }


  function ReturnToPreviousLikeAPreset(prev) {

    initializeFormState(NEW_UI);
    setDefaultStorage();
    initSatisfaction();

    let newStuff = [];
    if (prev !== undefined) {
      prev.forEach(transformer_id => {
        // 1. get context from preset id
        const context = idDependencyMap[transformer_id].get('context');
        const newState = formState;
        // 2. set all the id's constraints to true
        const widgetConfig = findWidgetByContext(config.form, context);
        if (widgetConfig && widgetConfig.transformers) {
          console.log(`Found ${widgetConfig.transformers.length} transformers for widget: ${context}`);
          widgetConfig.transformers.forEach(transformer => {


            if (transformer.id === transformer_id) {
              //if (Object.hasOwn(transformer,"contraints")) {
              transformer.constraints.forEach(constraint => {
                newState[constraint] = true;
                console.log("Setting constraint", constraint, " to true");
              });
              //}
            }
          });
        }

        setState({ formState: newState });
        //reCheckExistingVars(true, idDependencyMap[transformer_id])
        handleWidgetChange(idDependencyMap[transformer_id].get('context'), true);

      })
    }

  }
  function get_labels_for_individual_transformers(config_form) {
    const mydict = {}
    state.satisfied.map(id => {
      if (id in idDependencyMap) {
        mydict[id] = idDependencyMap[id].get('name')
      }
    })
    return mydict;
  }

  function togglePresets(presetID) {
    VARIABLES.presets.forEach(preset => {
      if (preset.id === presetID) {
        console.log('preset', preset)

        //this.setState({ variables: preset.variableIds }, () => { this.props.holdNewCriteria(this.state); });
        setState({ ...state, preset: presetID });
      }
    })

  }

  function changeBaseFromContextToIdsForSeparateItemsInSelectedVariablesPane(widgets) {
    var ids = []
    widgets.forEach(widget => {
      widget.variableIds.forEach(variableId => {
        if (state.satisfied.indexOf(variableId) !== -1) {
          if (ids.indexOf(variableId) === -1) {
            ids.push(variableId);
          }
        }
      })
    })
    return ids;
  }
  function doThePresets(preset_group) {
    const currentPreset = localStorage.getItem("currentPreset");
    return (
      <React.Fragment>
        <FormControl component="fieldset">
          <RadioGroup
            value={standardPlotSelection}

            onChange={(e) => handleStandardPlotChange(event.target.value)}
            name="presets-group"
          >

            {VARIABLES.presets.filter(item => item.family === preset_group).map((preset) => {
              const radioElement = (
                <FormControlLabel
                  key={preset.id}
                  id={"check_" + preset.id}
                  checked={currentPreset && currentPreset == preset.id ? true : false}
                  value={preset.id} // Value for the radio button
                  control={<Radio color="default" size="small" />} // MUI Radio button
                  label={preset.displayLabel} // Display label
                  className={`preset-radio preset-${preset.id}`}
                />
              );

              // Wrap with tooltip if tooltip text is provided
              if (preset.tooltip) {
                return (
                  <Tooltip key={preset.id} title={preset.tooltip} placement="top" arrow>
                    {radioElement}
                  </Tooltip>
                );
              }

              return radioElement;
            })}
          </RadioGroup>
        </FormControl>
      </React.Fragment>
    );
  }

  // Main render function for the new component
  const renderNewControlForm = (config) => {
    // Format date to match mockup format
    const formatDateForDisplay = () => {
      const date = selectedDate.date;
      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, '0');
      const day = String(date.getUTCDate()).padStart(2, '0');
      const hours = String(date.getUTCHours()).padStart(2, '0');
      const minutes = String(date.getUTCMinutes()).padStart(2, '0');
      return `${year}-${month}-${day}T${hours}:${minutes}`;
    };
    const full_satisfied = get_labels_for_individual_transformers(config.form);

    return (
      <React.Fragment>
        <div className='drawer-header'>
          <span className={"grid-title"}>
            <h1>Variables</h1>
            <span>Select variables to apply to the selected datetime: </span>
            <span>{selectedDate.displayTime}</span>
            <span>to</span>
            <span>{selectedDate.displayEndTime}</span>
          </span>
          <button aria-label="Close date selector drawer"
            className='close-drawer-button'
            onClick={() => props.closeDrawer()}></button>
        </div>

        <div className="new-control-form-container">
          {/* Left Panel - Standard Stack Plot */}
          <div className="new-control-form-left-panel">
            {/* Added -inner to move scroll bar away from edge */}
            <div className="new-control-form-left-panel-inner">
              <Typography variant="h6" className="new-control-form-panel-title">
                Standard Stack Plot
              </Typography>
              <Typography variant="body2" className="new-control-form-caution-text">
                Caution: a change here resets the custom selections
              </Typography>

              <Typography style={{ marginTop: "15px", fontSize: "1.1rem", color: "#3D3D3D" }} variant="subtitle2" className="new-control-form-section-title">
                Presets
              </Typography>
              {doThePresets("default")}
              <Typography style={{ marginTop: "15px", fontSize: "1.1rem", color: "#3D3D3D" }} variant="subtitle2" className="new-control-form-section-title">
                Regional
              </Typography>
              {doThePresets("regional")}
              <Typography style={{ marginTop: "15px", fontSize: "1.1rem", color: "#3D3D3D" }} variant="subtitle2" className="new-control-form-section-title">
                Multi-Spacecraft
              </Typography>
              {doThePresets("multi")}
              <Typography style={{ marginTop: "15px", fontSize: "1.1rem", color: "#3D3D3D" }} variant="subtitle2" className="new-control-form-section-title">
                Instrument Summary
              </Typography>
              {doThePresets("summary")}
            </div>
          </div>

          {/* Center Panel - Custom Stack Plot */}
          <div className="new-control-form-center-panel new-variable-ui-tour">
            {/* Added -inner to move scroll bar away from edge */}
            <div className="new-control-form-center-panel-inner">
              <Typography variant="h6" className="new-control-form-panel-title">
                Custom Stack Plot
              </Typography>

              {/* Render all sections from configuration */}
              <div className="new-control-form-accordion-details">
                {renderAllSections()}
              </div>
            </div>
          </div>

          {/* Right Panel - Selected Variables */}
          <div className='right-panel'>
            <div className="new-control-form-right-panel">
              {/* Added -inner to move scroll bar away from edge */}
              <div className="new-control-form-right-panel-inner">
                <Typography variant="h6" className="new-control-form-panel-title">
                  Selected Variables
                </Typography>
                <Typography variant="body2" className="new-control-form-caution-text">
                  Drag variables in this list to reorder them.
                </Typography>

                <div className="new-control-form-selected-vars-container">
                  {(() => {
                    const selectedVars = getSelectedVariablesForDisplay();
                    if (selectedVars.length === 0) {
                      return (
                        <div className="new-control-form-empty-state">
                          No variables selected yet. Select variables from the Custom Stack Plot to see them here.
                        </div>
                      );
                    }

                    const empty = selectedVars.filter(item => item.variableIds.length > 0);
                    var empty_ids = changeBaseFromContextToIdsForSeparateItemsInSelectedVariablesPane(empty);

                    if (empty.length === 0) { // we are trying to prevent attributes from being listed in the Selected Variables Pane
                      return (
                        <div className="new-control-form-empty-state">
                          No variables selected yet. Select variables from the Custom Stack Plot to see them here.
                        </div>
                      )
                    }
                    if (empty_ids.length > state.satisfied.length) {
                      empty_ids = state.satisfied;
                    }
                    console.log("empty presets", empty_ids);
                    return empty_ids.map((id, index) => {

                      const isDragging = draggedItem === id;
                      const isDragOver = dragOverItem === id;

                      return (
                        <Tooltip
                          title={idDependencyMap[id].get('cdf_data')?.[0]?.replace('{sc_num}', whichSpaceCraft()) || 'No data source'}
                          placement="top">
                          <div
                            key={id}
                            className={`new-control-form-selected-var-item ${isDragging ? 'dragging' : ''} ${isDragOver ? 'drag-over' : ''}`}
                            draggable
                            onDragStart={(event) => handleSelectedVarDragStart(event, id)}
                            onDragOver={(event) => handleSelectedVarDragOver(event, id)}
                            onDragLeave={handleSelectedVarDragLeave}
                            onDrop={(event) => handleSelectedVarDrop(event, id)}
                            onDragEnd={handleSelectedVarDragEnd}
                          >
                            <span className="new-control-form-selected-var-label">{full_satisfied[id]} </span>

                            <span className="new-control-form-drag-handle"><div className='drag-id'>{id} </div><div className='drag-handle'>☰</div></span>
                          </div>
                        </Tooltip>
                      );

                    });
                  })()}
                </div>

                {/* Buttons inside the right panel */}
              </div>
            </div>
            <div className="new-control-form-right-panel-buttons">
              <button
                className="revert-button"
                onClick={() => {
                  // Restore the saved variables order
                  restoreVariablesOrder();
                  console.log('Reverted to previous plot selections');
                }}
              >
                Revert to Previous Plot Selections

              </button>
              <button className='next-button'


                onClick={() => {
                  // Run final validation before generating plots
                  validateAndCleanupConstraints();

                  const { selectedVariables, selectedTransformers, variableIds } = processFormState();


                  // Validate that we have at least one variable selected
                  if (variableIds.length === 0) {
                    alert('Please select at least one variable to generate plots.');
                    return;
                  }

                  // Save the current variables order and selections before generating plots
                  // This must happen before the component potentially gets unmounted
                  saveVariablesOrder();

                  // Log any constraint issues
                  //console.log('Current form state:', formState);
                  //console.log('Constraint dependency map:', constraintDependencyMap);
                  const satisfiedSet = new Set(state.satisfied);

                  // Filter the mainArray to keep only elements present in the referenceSet
                  const filteredIds = variableIds.filter(item => satisfiedSet.has(item));

                  // Create the form state object that the backend expects
                  const formStateForBackend = {
                    ...state,
                    variables: selectUsingGutsOfRenderNewControlForm(), // Use the actual variable IDs for the backend
                    startTime: selectedDate.date,
                    duration: state.duration,
                    spacecraft: whichSpaceCraft(),
                    fst: selectFastOnly(),
                    bst: state.bst,
                    gsm: state.gsm,
                    zd: 0,
                    event: "none",
                    preset: 'preset1',
                    selectAll: false,
                    selectAllMult: false,
                    selectAllSing: false,
                    arrayorder: {},
                    units: "hours",
                    satisfied: state.satisfied
                  };

                  console.log('Form state for backend:', formStateForBackend);

                  // Call the proper callback that triggers plot generation
                  if (props.onGenerateClick) {
                    props.onGenerateClick(formStateForBackend);
                  }
                }}
              >
                Generate Plots<span class="rightarrow-form"></span>
              </button>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  };

  useEffect(() => {
    console.log('Initializing component with NEW_UI:', NEW_UI);
    // setConfig(NEW_UI);

    // On first load: open the first accordion (if any) and set default preset
    try {
      setTimeout(() => {
        let firstAccordionPath = null;
        const form = NEW_UI && NEW_UI.form;
        if (form) {
          const sectionKeys = Object.keys(form);
          outer: for (const sectionKey of sectionKeys) {
            const sectionConfig = form[sectionKey];
            const subsectionKeys = Object.keys(sectionConfig).filter(k => k !== 'title' && k !== 'widgets');
            for (const k of subsectionKeys) {
              const shouldUseAccordion = (sectionKey === 'particles' || sectionKey === 'em_fields') &&
                (k === 'low_to_mid_spect' || k === 'low_to_mid_moments' || k === 'high_energy_particle_spect' ||
                  k === 'b_field' || k === 'e_field');
              if (shouldUseAccordion) {
                firstAccordionPath = `${sectionKey}.${k}`;
                break outer;
              }
            }
          }
        }

        if (firstAccordionPath) {
          setExpandedSections(prev => ({ ...prev, [firstAccordionPath]: true }));
        }
      }, 500);
    } catch (e) {
      console.warn('Initial UI setup failed:', e);
    }


    // Build constraint dependency map
    const dependencyMap = buildConstraintDependencyMap(NEW_UI);
    console.log('Constraint dependency map:', dependencyMap);
    setConstraintDependencyMap(dependencyMap);

    // I'm using this to handle presets.
    const idDependencyMap = buildIdDependencyMap(NEW_UI);
    setIdDependencyMap(idDependencyMap);

    // Get initial form state
    const initialFormState = initializeFormState(NEW_UI);
    console.log('Initial form state:', initialFormState);

    // Restore saved variables data from localStorage
    console.log('=== COMPONENT INITIALIZATION ===');
    console.log('Checking localStorage for saved data...');

    const savedDataString = localStorage.getItem('savedVariablesData');

    const savedData = JSON.parse(savedDataString || '{"order": [], "selections": {}, "ids": [] }');

    if (savedData.ids == undefined || savedData.ids.length === 0) { // This is our Default Selected Variable list when the user opens the APP. - Our Jim Burch plot
      savedData.ids = displayVars;
      savedData.order = [
        "particles.low_to_mid_spect.omnidirectional.electrons",
        "custom_stack_plot.coordinates.gse",
        "particles.low_to_mid_spect.omnidirectional.units.psd",
        "particles.low_to_mid_moments.temperature.ploteachset.separate",
        "custom_stack_plot.coordinates.gse",
        "em_fields.b_field.ploteachset.together",
        "em_fields.b_field.options.all",
        "particles.low_to_mid_spect.omnidirectional.ions",
        "particles.low_to_mid_spect.omnidirectional.electrons",
        "particles.low_to_mid_moments.number_density.ploteachset.together",
        "particles.low_to_mid_moments.number_density.electrons",
        "particles.low_to_mid_moments.velocity.ploteachset.separate",
        "particles.low_to_mid_moments.velocity.ions",
        "particles.low_to_mid_moments.temperature.ions",
        "particles.low_to_mid_moments.velocity.electrons",
        "particles.low_to_mid_moments.number_density.electrons",
        "custom_stack_plot.tracker.burst",
        "particles.low_to_mid_moments.temperature.ions",
        "particles.low_to_mid_moments.temperature.electrons",
        "custom_stack_plot.ephemeris"];

      savedData.selections = {}
      savedData.selections["custom_stack_plot.tracker.burst"] = true;
      savedData.selections["custom_stack_plot.coordinates.gse"] = true;

      savedData.selections["em_fields.b_field.plot.components"] = true;
      savedData.selections["em_fields.b_field.ploteachset.together"] = true;
      savedData.selections["em_fields.b_field.options.all"] = true;

      savedData.selections["particles.low_to_mid_spect.omnidirectional.electrons"] = true;
      savedData.selections["particles.low_to_mid_spect.omnidirectional.ions"] = true;
      savedData.selections["particles.low_to_mid_spect.omnidirectional.units.psd"] = true;

      savedData.selections["particles.low_to_mid_moments.number_density.electrons"] = true;
      savedData.selections["particles.low_to_mid_spect.omnidirectional.electrons"] = true;

      savedData.selections["particles.low_to_mid_moments.number_density.ploteachset.together"] = true;
      savedData.selections["particles.low_to_mid_moments.number_density.electrons"] = true;
      savedData.selections["particles.low_to_mid_moments.velocity.ploteachset.separate"] = true;
      savedData.selections["particles.low_to_mid_moments.velocity.ions"] = true;
      savedData.selections["particles.low_to_mid_moments.velocity.electrons"] = true;
      savedData.selections["particles.low_to_mid_moments.temperature.ploteachset.separate"] = true;

      savedData.selections["particles.low_to_mid_moments.temperature.ions"] = true;
      savedData.selections["particles.low_to_mid_moments.temperature.electrons"] = true;
      savedData.selections["custom_stack_plot.ephemeris"] = true
    }
    if (savedData.order && savedData.order.length > 0) {
      setSavedVariablesOrder(savedData.order);
      setSelectedVariablesOrder(savedData.order); // Apply the saved order immediately
      console.log('Loaded and applied saved variables order from localStorage:', savedData.order);
    } else {
      console.log('No saved order found in localStorage');
    }

    if (savedData.selections && Object.keys(savedData.selections).length > 0) {
      setSavedVariableSelections(savedData.selections);
      console.log('Loaded saved variable selections from localStorage:', savedData.selections);

      // Force apply saved selections to form state immediately
      console.log('Force applying saved selections to form state...');
      setFormState(savedData.selections);

      // Also merge with initial form state as backup
      const mergedFormState = { ...initialFormState, ...savedData.selections };
      console.log('Merged form state with saved selections:', mergedFormState);

      // Use a timeout to ensure the state is set
      setTimeout(() => {
        console.log('Setting merged form state after timeout...');
        setFormState(mergedFormState);
      }, 100);
    } else {
      console.log('No saved selections found in localStorage, using initial form state');
      // setFormState(initialFormState);
      // console.log('initialFormState', initialFormState);
      // setFormState(defaultPreset);
      handleStandardPlotChange("preset0");
    }

    // Restore saved date/time if available
    if (savedData.startTime) {
      try {
        const savedStartTime = new Date(savedData.startTime);
        selectedDate.date = savedStartTime;
        selectedDate.displayTime = savedStartTime.toISOString().slice(0, 16).replace('T', ' ');
        console.log('Restored saved start time:', savedStartTime);
      } catch (e) {
        console.warn('Failed to restore saved start time:', e);
      }
    }

    if (savedData.duration !== undefined) {
      setState(prevState => ({
        ...prevState,
        duration: savedData.duration
      }));
      console.log('Restored saved duration:', savedData.duration);

      // Calculate and set displayEndTime
      if (savedData.startTime) {
        const endDate = new Date(moment(selectedDate.date).add(savedData.duration, 'hours'));
        const endTime = (endDate.getUTCHours() < 10 ? '0' : '') + endDate.getUTCHours() + ':' + (endDate.getUTCMinutes() < 10 ? '0' : '') + endDate.getUTCMinutes();
        selectedDate.displayEndTime = (endDate.getUTCFullYear() + '-' +
          ((endDate.getUTCMonth() + 1) < 10 ? '0' : '') + (endDate.getUTCMonth() + 1) + '-' +
          (endDate.getUTCDate() < 10 ? '0' : '') + endDate.getUTCDate() + ' ' + endTime);
        console.log('Calculated displayEndTime in useEffect:', selectedDate.displayEndTime);
      }
    }

    setState({
      ...state,
      arrayorder: props.defaults.arrayorder,
      onGenerateClick: props.onGenerateClick,
      duration: selectedDate.duration // Use restored duration from localStorage
    });

    // Pass the updated state with correct duration to holdNewCriteria
    const updatedDefaults = {
      ...props.defaults,
      duration: selectedDate.duration
    };
    props.holdNewCriteria(updatedDefaults);
  }, []);

  // Run validation and cleanup when dependency map is ready
  useEffect(() => {
    if (Object.keys(constraintDependencyMap).length > 0 && config) {
      console.log('Running constraint validation and cleanup...');
      validateAndCleanupConstraints();
      initSatisfaction(); // this important in restoring the selectedVariables list after going to another tab
    }
  }, [constraintDependencyMap, config]);

  // Auto-save form state changes to localStorage (but not on initial load)
  useEffect(() => {
    // Only save if we have a meaningful form state (not just initial state)
    if (Object.keys(formState).length > 0 && config) {
      const hasSelections = Object.values(formState).some(value => value === true || (typeof value === 'string' && value !== ''));
      if (hasSelections) {
        //console.log('=== AUTO-SAVE TRIGGERED ===');
        //console.log('Current form state:', formState);

        // Save current selections but keep existing order
        const currentOrder = selectedVariablesOrder.length > 0 ?
          selectedVariablesOrder :
          getSelectedVariablesForDisplay().map(v => v.context);

        const savedData = {
          order: currentOrder,
          selections: formState,
          ids: state.satisfied
        };

        console.log('Saving to localStorage:', savedData);
        localStorage.setItem('savedVariablesData', JSON.stringify(savedData));
        setSavedVariableSelections(formState);
        if (currentOrder.length > 0) {
          setSavedVariablesOrder(currentOrder);
        }
        console.log('Auto-save completed');
      }
    }
  }, [formState, selectedVariablesOrder, config]);

  // Debug function to check localStorage (can be called from browser console)
  window.debugLocalStorage = () => {
    console.log('=== LOCALSTORAGE DEBUG ===');
    const data = localStorage.getItem('savedVariablesData');
    console.log('Raw localStorage data:', data);
    if (data) {
      const parsed = JSON.parse(data);
      console.log('Parsed data:', parsed);
      console.log('Order:', parsed.order);
      console.log('Selections:', parsed.selections);
    } else {
      console.log('No saved data found in localStorage');
    }
  };


  window.setDefaultStorage = () => {

    Object.keys(formState).forEach(key => {
      const widgetConfig = findWidgetByContext(config.form, key);
      if (widgetConfig != null && widgetConfig.hasOwnProperty('default')) {
        if (widgetConfig.default) {
          formState[key] = true;
          console.log('Setting form state:', key, formState[key]);

        }
      }
      else {
        formState[key] = false;
      }
    })


    localStorage.setItem('savedVariablesData', JSON.stringify(formState));
    window.applySavedData();
    if (state.satisfied.length > 0) {
      console.log('✅ Plottable Vars are set');
    }
    else {
      console.log('❌ Failed to set up state.satisfied');
    }
    setFormState(formState);
  };

  // Function to manually apply saved data (can be called from browser console)
  window.applySavedData = () => {
    console.log('=== MANUALLY APPLYING SAVED DATA ===');
    const savedDataString = localStorage.getItem('savedVariablesData');
    if (savedDataString) {
      const savedData = JSON.parse(savedDataString);
      console.log('Applying saved data:', savedData);

      if (savedData.selections) {
        console.log('Setting form state to saved selections...');
        setFormState(savedData.selections);
      }

      if (savedData.order) {
        console.log('Setting variables order to saved order...');
        setSelectedVariablesOrder(savedData.order);
        setSavedVariablesOrder(savedData.order);
      }

      console.log('✅ Saved data applied manually');
    } else {
      console.log('❌ No saved data found to apply');
    }
  };

  // Function to test processFormState (can be called from browser console)
  window.testProcessFormState = () => {
    console.log('=== TESTING PROCESSFORMSTATE ===');
    const result = processFormState();
    console.log('processFormState result:', result);
    console.log('Variable IDs that would be sent to backend:', result.variableIds);
    return result;
  };

  // Return the rendered component

  if (config != null && Object.keys(idDependencyMap).length > 1 && state.satisfied != undefined) {
    return renderNewControlForm(config);
  }
};




class ControlFormDateTime extends Component {
  constructor(props) {
    super(props);
    //this.newList = {};
    //Below goes to variables
    //this.onGenerateClick = this.onGenerateClick.bind(this);
    //Below goes to varaibles
    //this.CaptureListStuff = this.CaptureListStuff.bind(this);
    //Below is time
    //this.onRowClick = this.onRowClick.bind(this);
    //Below is time
    this.triggerSearch = this.triggerSearch.bind(this);
    this.IncludeDates = this.importDatesToInclude();
    this.setSearchDateTime = this.setSearchDateTime.bind(this);
    const arrayorder = {};
    // maintain the DatePicker yearDropDown
    this.yearRange = new Date()
    // this.yearRange.setFullYear(this.yearRange.getFullYear() + 1);
    this.minDateObj = { year: 2015, month: 9, day: 1 };
    this.maxDateObj = { year: this.yearRange.getFullYear(), month: this.yearRange.getMonth(), day: this.yearRange.getDate() };
    this.initialLoad = true;
    // Handle long and short(url) variable names
    if (VARIABLES.options.idformat === 'long') {
      VARIABLES.categories
        .filter(variable => variable.full_id)
        .forEach(variable => {
          variable.id = variable.full_id;
          //variable.selectionAlsoSelects = variable.full_selectionAlsoSelects;
        })
    };

    // VARIABLES.categories.forEach(category => {
    //     arrayorder[category.title] = [];
    // });

    // Check if we have saved data in localStorage to restore
    let savedData = null;
    try {
      const savedDataString = localStorage.getItem('savedVariablesData');
      if (savedDataString) {
        savedData = JSON.parse(savedDataString);
      }
    } catch (e) {
      console.warn('Failed to parse saved data in ControlFormDateTime constructor:', e);
    }

    // Use saved duration and date/time if available, otherwise use props or defaults
    const useSavedData = savedData && savedData.startTime && savedData.duration !== undefined;
    const initialDuration = useSavedData ? savedData.duration : (props.duration || selectedDate.duration || 2);

    // Ensure selectedDate.duration is in sync
    if (useSavedData) {
      selectedDate.duration = savedData.duration;
    }

    // Create dateObj with exact time (don't round minutes when restoring saved data)
    const dateObjTime = useSavedData ?
      (selectedDate.date.getUTCHours() < 10 ? '0' : '') + selectedDate.date.getUTCHours() + ':' +
      (selectedDate.date.getUTCMinutes() < 10 ? '0' : '') + selectedDate.date.getUTCMinutes() :
      (selectedDate.date.getUTCHours() < 10 ? '0' : '') + selectedDate.date.getUTCHours() + ':' +
      (selectedDate.date.getUTCMinutes() < 30 ? '00' : '30');

    this.state = {
      duration: initialDuration,
      units: "hours",
      event: "none",
      startTime: new Date(Constants.DEFAULT_START_TIME),
      endTime: "none",
      context: 'landingpage',
      initialSearchQuery: "GSM",
      searchbox_label: props.searchbox_label || "SITL Comment:",
      searchQuery: props.searchQuery || props.initialSearchQuery || "",
      searchData: "none",
      sitl_present: null,
      searchType: 'sitl', // 'sitl' or 'papers'
      dateObj: {
        showYear: selectedDate.date.getUTCFullYear(),
        year: selectedDate.date.getUTCFullYear(),
        month: selectedDate.date.getUTCMonth() + 1,
        day: selectedDate.date.getUTCDate(),
        time: dateObjTime
      },
      //calendar: this.createMonthsCalendar(true)
    };

    // Apply props.defaults only if we're not using saved data from localStorage
    if (props.defaults && !useSavedData) {
      for (let key in props.defaults) {
        if (this.state[key] !== null) {
          this.state[key] = props.defaults[key];
        }
        if (key === 'startTime') {
          selectedDate.date = new Date(props.defaults[key]);
          this.state.dateObj = {
            showYear: selectedDate.date.getUTCFullYear(),
            year: selectedDate.date.getUTCFullYear(),
            month: selectedDate.date.getUTCMonth() + 1,
            day: selectedDate.date.getUTCDate(),
            time: (selectedDate.date.getUTCHours() < 10 ? '0' : '') + selectedDate.date.getUTCHours() + ':' + (selectedDate.date.getUTCMinutes() < 30 ? '00' : '30')
          };
        }
      }

      if (this.state.duration > 6) {
        this.state.units = "minutes"
      }
      else {
        this.state.units = "hours"
      }
      this.state.context = 'resultspage';
      this.state.initialSearchQuery = props.initialSearchQuery || props.defaults.initialSearchQuery;
    }

    // Set units based on duration (whether from saved data or props)
    if (this.state.duration > 6) {
      this.state.units = "minutes"
    }
    else {
      this.state.units = "hours"
    }

    this.state.calendar = this.createMonthsCalendar(true);


    // this.setState({dateObj: {year: 2024, month: 10, day: 16, time: '09:00'}});
    // this.setState({calendar: this.createMonthsCalendar(2024)});
  } // end contructor



  /*
 SITL Search sent over to MuiTable
  */
  triggerSearch(ev) {
    console.log("triggerSearch: " + this.state.searchQuery);
    axios.get('/api/search_results?q=' + this.state.searchQuery)
      .then((response) => {
        const rows = response.data.brstsegs;
        var firstdata = [];
        for (var i = 0; i < rows.length; ++i) {
          firstdata.push(this.createData(i, rows[i].comment, rows[i].first_buffer, rows[i].fom));
        }
        this.setState({ searchData: firstdata });
        const formState = Object.assign({}, this.state);
        console.log(' this.props', this.props);
        console.log('this.state', this.state);
        //this.props.toNewMuiClick(formState);
      });
  };
  createData(id, comment, time, fom) {
    return { id: id, comment, time, fom };
  };

  //Dont need this anymore
  // onRowClick(selectedTime) {
  //     this.setState({ startTime: selectedTime });
  // }

  setSearchDateTime(value) {
    //Saving this state for using for the varaibles
    this.setState({
      searchDate: value
    })
    this.setClanderToDate(value);
  }


  importDatesToInclude() {
    const dates = [];
    if (Utils.areWeTestingWithJest()) {
      dates.push(new Date());
      return dates;
    }

    axios.get(`/api/include_dates?file=on_backend`
    ).then(resp => {
      if (resp.data.error) {
        const { message } = resp.data;
        const redirect = <Redirect to={`/error/${message}`} />
        this.setState({ redirect });
        return;
      }

      const {
        results
      } = resp.data;
      results.forEach(thisdate => {
        dates.push(new Date(thisdate));
      });
      this.get_latest_date(dates);

    })
      .catch(error => {
        if (!Utils.areWeTestingWithJest()) {
          const message = "An unknown error downloading included dates. Using default set";
          //console.log(message);
        }
        // if the file isn't under temp on the server, get this default set
        // which is shipped with the application:
        DEFAULT_INCLUDE_DATES.forEach(thisdate => {
          var thisDate = new Date(thisdate);
          var zd = this.calculate_zone(thisDate);
          thisDate.setHours(thisDate.getHours() + zd);

          dates.push(new Date(thisdate));
        });

      })
    return dates;

  }
  /**
  * Called immediately after the component is added to the DOM.
  */
  componentDidMount() {

    this.get_latest_sitl_date();
    /* This disables the ability to edit the date directly
    const datePicker = document.getElementsByClassName("new-date-picker")[0];
    const input = datePicker.children[0].children[0].children[0];
    input.setAttribute('readonly', true);
    input.setAttribute('type', 'button');
     */
    // VARIABLES.categories.forEach(category => {
    //     this.CaptureListStuff(category.title);
    // });
    /* critical for using SITL start time... */
    if (this.props.startTime) {
      this.setState({ startTime: this.props.startTime });
    }
    if (this.props.initialSearchQuery != null && this.props.initialSearchQuery != "") {
      this.setState({ searchQuery: this.props.initialSearchQuery });
      console.log("reset searchQuery to: " + this.state.searchQuery);
    }

  }

  get_latest_date(dates) {
    var latest = DEFAULT_INCLUDE_DATES.slice(-1).toString();
    if (dates && dates.length > 1) {
      latest = dates.slice(-1).toString();
    }
    this.setState({ present: latest });
  }

  get_latest_sitl_date() {
    var latest = this.present;
    axios.get('/api/latest_sitl_date?q=' + this.initialSearchQuery)
      .then((response) => {
        latest = response.data.brstsegs[0].first_buffer;
        let aviation = this.getStartTimeForDatePicker(latest, true);
        this.setState({ sitl_present: aviation }); /* see import statement at top of page */
      });
  }

  getStartTimeForDatePicker = (datestring_from_row, alreadyGMT) => {

    var input = new Date(datestring_from_row);
    var zd = 0;
    if (!alreadyGMT) {
      zd = this.calculate_zone(input);
    }
    input.setHours(input.getHours() - zd);
    // First GMT
    // Then 2 hour setup.. if minutes > 30 then we'll do that hour
    input.setSeconds(0);
    var align_min = input.getMinutes();
    console.log(align_min);
    console.log("align_min: " + align_min);
    if (align_min > 0) {
      if (align_min > 30) {
        input.setMinutes(0);
      } else {
        input.setHours(input.getHours() - 1);
        input.setMinutes(0);
      }
    }
    return input;
  }


  calculate_zone(eventdate) {

    if (eventdate) {
      var myLocal = eventdate.getHours();
      var myUtc = eventdate.getUTCHours();
      if (myUtc <= 4) {
        myUtc += 24;
      }
      return myLocal - myUtc;
    }
    return 0
  }


  // when dateObj is changed inorder for it to be reflected in the clander this function must be called in the callback
  // ex: this.setState({dateObj: obj}, () => {this.createMonthsCalendar(true)});
  createMonthsCalendar(scrollToDate) {
    let leapYear = (this.state.dateObj.showYear % 4 === 0);
    let startDate = moment(`${this.state.dateObj.showYear}-01-01`, "YYYY-MM-DD");
    let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    let monthStartDay = days.indexOf(startDate.format('dddd'));
    let calendarObj = {
      'January': { 'daycount': 31, 'display': [], 'num': 1 },
      'February': { 'daycount': (leapYear === true ? 29 : 28), 'display': [], 'num': 2 },
      'March': { 'daycount': 31, 'display': [], 'num': 3 },
      'April': { 'daycount': 30, 'display': [], 'num': 4 },
      'May': { 'daycount': 31, 'display': [], 'num': 5 },
      'June': { 'daycount': 30, 'display': [], 'num': 6 },
      'July': { 'daycount': 31, 'display': [], 'num': 7 },
      'August': { 'daycount': 31, 'display': [], 'num': 8 },
      'September': { 'daycount': 30, 'display': [], 'num': 9 },
      'October': { 'daycount': 31, 'display': [], 'num': 10 },
      'November': { 'daycount': 30, 'display': [], 'num': 11 },
      'December': { 'daycount': 31, 'display': [], 'num': 12 }
    }
    for (let month in calendarObj) {
      let weekCount = 0;
      let weekHTML = [];
      for (let i = 0; (i < calendarObj[month]['daycount'] + monthStartDay) || !(weekCount === 0); i++) {
        let dayNumber = i + 1 - monthStartDay;
        if ((i < monthStartDay && monthStartDay > weekCount) || i >= calendarObj[month]['daycount'] + monthStartDay) {
          weekHTML.push(<div className='day blank'></div>);
          weekCount++;
        } else {
          let notInRange = ((this.maxDateObj.year <= this.state.dateObj.showYear)
            && (((this.maxDateObj.month === calendarObj[month]['num'])
              && (this.maxDateObj.day < dayNumber)) || this.maxDateObj.month < calendarObj[month]['num']))
            || ((this.minDateObj.year >= this.state.dateObj.showYear)
              && (((this.minDateObj.month === calendarObj[month]['num'])
                && (this.minDateObj.day > dayNumber)) || this.minDateObj.month > calendarObj[month]['num']));
          weekHTML.push(<button
            className={'day ' + (((this.state.dateObj.day === dayNumber) &&
              (calendarObj[month]['num'] === this.state.dateObj.month) &&
              (this.state.dateObj.showYear === this.state.dateObj.year)) ? 'slectedDay' : '')}
            onClick={() => {
              let obj = this.state.dateObj;
              obj.month = calendarObj[month]['num'];
              obj.day = dayNumber;
              obj.year = this.state.dateObj.showYear;
              let time = this.state.dateObj.time.split(':');
              selectedDate.date = new Date(Date.UTC(obj.year, obj.month - 1, obj.day, time[0], time[1]));
              this.setState({ startTime: selectedDate.date }, () => { this.props.holdNewCriteria(this.state); });
              this.setState({ dateObj: obj }, () => { this.createMonthsCalendar(false) });
              this.saveDateTimeToLocalStorage();
            }}
            disabled={notInRange}
          >
            {dayNumber}
          </button>);
          weekCount++;
        }
        if (weekCount === 7) {
          calendarObj[month]['display'].push(<div className='week'>{weekHTML}</div>);
          weekCount = 0;
          weekHTML = [];
        }
      }
      monthStartDay = (monthStartDay + calendarObj[month]['daycount']) % 7;
    }
    calendarObj.days = (<div className='week'><div className='day'>S</div>
      <div className='day letter'>M</div>
      <div className='day letter'>T</div>
      <div className='day letter'>W</div>
      <div className='day letter'>T</div>
      <div className='day letter'>F</div>
      <div className='day letter'>S</div></div>);
    this.setState({ calendar: calendarObj }, () => {
      if (this.state.dateObj.showYear === this.state.dateObj.year && scrollToDate) {
        this.scrollToSelected()
      }
    });
    return calendarObj;
  }

  // Helper function to save date/time changes to localStorage
  saveDateTimeToLocalStorage() {
    try {
      const savedDataString = localStorage.getItem('savedVariablesData');
      const savedData = savedDataString ? JSON.parse(savedDataString) : {};
      savedData.startTime = selectedDate.date.toISOString();
      savedData.duration = this.state.duration;
      localStorage.setItem('savedVariablesData', JSON.stringify(savedData));
      console.log('Saved date/time to localStorage:', savedData.startTime, 'duration:', savedData.duration);
    } catch (e) {
      console.warn('Failed to save date/time to localStorage:', e);
    }
  }

  // used to create selectable time in date time section 
  createTimeDisplay() {
    let timeDisplay = []
    for (let x = 0; x < 24; x++) {
      if (x < 10) {
        timeDisplay.push(<button
          className={'timeDisplay ' + (this.state.dateObj.time === '0' + x + ':00' ? 'selectedTime' : '')}
          onClick={() => {
            let obj = this.state.dateObj;
            obj.time = '0' + x + ':00';
            selectedDate.date = new Date(Date.UTC(obj.year, obj.month - 1, obj.day, '0' + x, '00'));
            this.setState({ startTime: selectedDate.date }, () => { this.props.holdNewCriteria(this.state); });
            this.setState({ dateObj: obj });
            this.saveDateTimeToLocalStorage();
          }}
        >{'0' + x + ':00'}</button>);
        timeDisplay.push(<button
          className={'timeDisplay ' + (this.state.dateObj.time === '0' + x + ':30' ? 'selectedTime' : '')}
          onClick={() => {
            let obj = this.state.dateObj;
            obj.time = '0' + x + ':30';
            selectedDate.date = new Date(Date.UTC(obj.year, obj.month - 1, obj.day, '0' + x, '30'));
            this.setState({ startTime: selectedDate.date }, () => { this.props.holdNewCriteria(this.state); });
            this.setState({ dateObj: obj });
            this.saveDateTimeToLocalStorage();
          }}
        >{'0' + x + ':30'}</button>);
      } else {
        timeDisplay.push(<button
          className={'timeDisplay ' + (this.state.dateObj.time === x + ':00' ? 'selectedTime' : '')}
          onClick={() => {
            let obj = this.state.dateObj;
            obj.time = x + ':00';
            selectedDate.date = new Date(Date.UTC(obj.year, obj.month - 1, obj.day, x, '00'));
            this.setState({ startTime: selectedDate.date }, () => { this.props.holdNewCriteria(this.state); });
            this.setState({ dateObj: obj });
            this.saveDateTimeToLocalStorage();
          }}>{x + ':00'}</button>);
        timeDisplay.push(<button
          className={'timeDisplay ' + (this.state.dateObj.time === x + ':30' ? 'selectedTime' : '')}
          onClick={() => {
            let obj = this.state.dateObj;
            obj.time = x + ':30';
            selectedDate.date = new Date(Date.UTC(obj.year, obj.month - 1, obj.day, x, '30'));
            this.setState({ startTime: selectedDate.date }, () => { this.props.holdNewCriteria(this.state); });
            this.setState({ dateObj: obj });
            this.saveDateTimeToLocalStorage();
          }}
        >{x + ':30'}</button>);
      }
    }
    return timeDisplay;
  }

  // sets Clander to reflect new date selected through featured events or SITL search
  // newDateInput parm must work with new Date function. ex: 2015-09-19T07:43:30Z
  setClanderToDate(newDateInput, exactTime) {
    let newDataObj = this.state.dateObj;
    if (exactTime) {
      selectedDate.date = new Date(newDateInput);
    } else {
      selectedDate.date = new Date(moment(newDateInput).add(-(selectedDate.duration / 2), this.state.units));
    }
    newDataObj.year = selectedDate.date.getUTCFullYear();
    newDataObj.showYear = selectedDate.date.getUTCFullYear();
    newDataObj.month = selectedDate.date.getUTCMonth() + 1;
    newDataObj.day = selectedDate.date.getUTCDate();
    newDataObj.time = (selectedDate.date.getUTCHours() < 10 ? '0' : '') + selectedDate.date.getUTCHours() + ':' + ((selectedDate.date.getUTCMinutes() < 15 || selectedDate.date.getUTCMinutes() > 45) ? '00' : '30');
    let time = newDataObj.time.split(':');
    selectedDate.date = new Date(Date.UTC(newDataObj.year, newDataObj.month - 1, newDataObj.day, time[0], time[1]));
    this.setState({ dateObj: newDataObj }, () => { this.createMonthsCalendar(true); });
    this.setState({ startTime: selectedDate.date }, () => { this.props.holdNewCriteria(this.state); });
    this.saveDateTimeToLocalStorage();
    return;
  }

  // Scroll to selected values on clander.
  scrollToSelected(attempt) {
    this.initialLoad = false;
    attempt = attempt || 1;
    // used to move selected time and date into view without having to scroll.
    let scrollToDay = document.getElementsByClassName("slectedDay")[0];
    if (scrollToDay) {
      scrollToDay.scrollIntoView({ behavior: "smooth", block: "center" });
    } else {
      if (attempt < 10) {
        // put in recursive timeout with limit of 10 because element doesnt exist on the first call of this function.
        setTimeout(() => {
          this.scrollToSelected(attempt + 1);
        }, 100);
      }
    }
    let scrollToTime = document.getElementsByClassName("selectedTime")[0];
    if (scrollToTime) {
      setTimeout(() => {
        scrollToTime.scrollIntoView({ behavior: "smooth", block: "center" });
      }, 700);
    } else {
      if (attempt < 10) {
        setTimeout(() => {
          this.scrollToSelected(attempt + 1);
        }, 100);
      }
    }
    return;
  }

  render() {
    // Build list of elements for the events picker
    const eventMenuItems = [];
    EVENTS.events.forEach(eventObj => {
      const menuItem = (
        <ListItemButton
          className={((new Date(eventObj.displayLabel) > selectedDate.date && new Date(eventObj.displayLabel) < moment(selectedDate.date).add(selectedDate.duration, this.state.units)) ? 'slectedTime' : '') + ' featuredEventButton'}
          value={eventObj.key}
          key={eventObj.key}
          onClick={() => {
            this.setState({ event: eventObj.key });
            this.setClanderToDate(eventObj.displayLabel);
          }
          }>
          <ListItemText 
            className='featuredListText'
            primary={`${eventObj.key} - ${eventObj.displayLabel}`}
            secondary={eventObj.description}
          />
        </ListItemButton>
      );
      eventMenuItems.push(menuItem);
    });

    let timeDisplay = this.createTimeDisplay()
    selectedDate.displayTime = (this.state.dateObj.year + '-' +
      (this.state.dateObj.month < 10 ? '0' : '') + this.state.dateObj.month + '-' +
      (this.state.dateObj.day < 10 ? '0' : '') + this.state.dateObj.day + ' ' + this.state.dateObj.time);
    // endTime
    let endDate = new Date(moment(selectedDate.date).add((selectedDate.duration), this.state.units));
    let endTime = (endDate.getUTCHours() < 10 ? '0' : '') + endDate.getUTCHours() + ':' + (endDate.getUTCMinutes() < 10 ? '0' : '') + endDate.getUTCMinutes();
    selectedDate.displayEndTime = (endDate.getUTCFullYear() + '-' +
      ((endDate.getUTCMonth() + 1) < 10 ? '0' : '') + (endDate.getUTCMonth() + 1) + '-' +
      (endDate.getUTCDate() < 10 ? '0' : '') + endDate.getUTCDate() + ' ' + endTime);
    if (this.initialLoad) {
      this.scrollToSelected();
    }
    return (
      <React.Fragment>
        <div className='drawer-header'>
          <span className={"grid-title"} onClick={() => {
            let obj = this.state.dateObj;
            obj.showYear = this.state.dateObj.year;
            this.setState({ dateObj: obj }, () => {
              this.createMonthsCalendar(true)
            });
          }}>
            <h1>Datetime</h1>
            <span style={{
              letterSpacing: '1px',
            }}>Selected time-span: </span>
            <span>{selectedDate.displayTime}</span>
            <span className='to-spacing'>to</span>
            <span className='to-spacing'>{selectedDate.displayEndTime}</span>
          </span>
          <button aria-label="Close date selector drawer"
            className='close-drawer-button'
            onClick={() => this.props.closeDrawer()}></button>
        </div>
        <Grid
          className='drawer-grid'
          container
          columnSpacing={3}
          style={{
            marginLeft: '16px',
            marginRight: '30px',
            marginTop: '25px',
            width: 'auto',
            height: '100%'
          }}>

          <Grid item xs={12} sm={12} md={3} lg={2.7} xl={2.7} >
            <div className={"item-border item-container"}>
              <h2 className='subheader'>Date / Time</h2>
              <div className='selection-container'>
                <button className='latest-data-button' onClick={() => {
                  this.setClanderToDate(this.state.sitl_present, true)
                  this.setState({ units: 'hours' });
                  this.setState({ duration: 1 }, () => {
                    this.props.holdNewCriteria(this.state);
                    this.saveDateTimeToLocalStorage();
                  });
                }}>
                  <span>Most Recent Burst</span>
                  <span className='latest-burst-time'>{this.state.sitl_present !== null ? this.state.sitl_present.toISOString().slice(0, -8) : ''}</span>
                </button>
              </div>
              <div className='yearPicker'>
                <button
                  className='yearNav leftarrow-year'
                  onClick={() => {
                    let obj = this.state.dateObj;
                    obj.showYear = this.state.dateObj.showYear - 1;
                    this.setState({ dateObj: obj }, () => {
                      this.createMonthsCalendar(true)
                    });
                  }}
                  disabled={this.minDateObj.year >= this.state.dateObj.showYear}
                  aria-label="move selected right"
                >
                </button>
                <h3 className='yearTitle'>{this.state.dateObj.showYear}</h3>
                <button
                  className='yearNav rightarrow-year'
                  onClick={() => {
                    let obj = this.state.dateObj;
                    obj.showYear = this.state.dateObj.showYear + 1;
                    this.setState({ dateObj: obj }, () => {
                      this.createMonthsCalendar(true)
                    });
                  }}
                  disabled={this.maxDateObj.year <= this.state.dateObj.showYear}
                  aria-label="move selected right"
                >
                </button>
              </div>
              <hr class="divider"></hr>
              <div className='calendarAlignment'>
                <div className='dayPicker'>
                  <h3 className='monthTitle'>January</h3>
                  {this.state.calendar.days}
                  {this.state.calendar.January.display}
                  <h3 className='monthTitle'>February</h3>
                  {this.state.calendar.days}
                  {this.state.calendar.February.display}
                  <h3 className='monthTitle'>March</h3>
                  {this.state.calendar.days}
                  {this.state.calendar.March.display}
                  <h3 className='monthTitle'>April</h3>
                  {this.state.calendar.days}
                  {this.state.calendar.April.display}
                  <h3 className='monthTitle'>May</h3>
                  {this.state.calendar.days}
                  {this.state.calendar.May.display}
                  <h3 className='monthTitle'>June</h3>
                  {this.state.calendar.days}
                  {this.state.calendar.June.display}
                  <h3 className='monthTitle'>July</h3>
                  {this.state.calendar.days}
                  {this.state.calendar.July.display}
                  <h3 className='monthTitle'>August</h3>
                  {this.state.calendar.days}
                  {this.state.calendar.August.display}
                  <h3 className='monthTitle'>September</h3>
                  {this.state.calendar.days}
                  {this.state.calendar.September.display}
                  <h3 className='monthTitle'>October</h3>
                  {this.state.calendar.days}
                  {this.state.calendar.October.display}
                  <h3 className='monthTitle'>November</h3>
                  {this.state.calendar.days}
                  {this.state.calendar.November.display}
                  <h3 className='monthTitle'>December</h3>
                  {this.state.calendar.days}
                  {this.state.calendar.December.display}
                </div>
                <div className='timePicker'>
                  {timeDisplay}
                </div>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={7.3} xl={7.3} >
            <div className={"item-border item-container SITL"}>
              <h2 className='subheader'>Event Search</h2>
              <FormControl component="fieldset" style={{ marginBottom: '10px', width: '100%' }}>
                <RadioGroup
                  row
                  aria-labelledby="search-type-radio-buttons"
                  value={this.state.searchType}
                  onChange={(event) => {
                    this.setState({ searchType: event.target.value });
                  }}
                  style={{ justifyContent: 'center' }}
                >
                  <FormControlLabel 
                    value="sitl" 
                    control={<Radio color="default" size="small" />} 
                    label="SITL Comments" 
                  />
                  <FormControlLabel 
                    value="papers" 
                    control={<Radio color="default" size="small" />} 
                    label="Scientific Papers" 
                  />
                  <FormControlLabel 
                    value="featured" 
                    control={<Radio color="default" size="small" />} 
                    label="Featured Events" 
                  />
                </RadioGroup>
              </FormControl>
              {this.state.searchType === 'sitl' ? (
                <SITLSearch
                  setSearchDateTime={this.setSearchDateTime}
                  searchTerm={this.props.sitlSearchTerm}
                  setSearchTerm={this.props.setSitlSearchTerm}
                  setClanderToDate={(e) => this.setClanderToDate(e)}
                  dateObj={{
                    date: selectedDate.date,
                    duration: selectedDate.duration,
                    units: this.state.units,
                  }}
                />
              ) : this.state.searchType === 'papers' ? (
                <SciencePaperSearch
                  onTimestampClick={(date) => {
                    console.log('Timestamp clicked in Datetime drawer, setting date to:', date);
                    this.setClanderToDate(date, true);
                  }}
                />
              ) : (
                <div className="featured-events-content">
                  <div className='selection-container' style={{ marginBottom: '10px' }}>
                    <a className='reference-button' href='https://doi.org/10.1029/2018JA025245' target="_blank">
                      Reference
                    </a>
                  </div>
                  <List className={"list-style"}>
                    {eventMenuItems}
                  </List>
                </div>
              )}
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={3} lg={2} xl={2} >
            <div className={"item-border item-container selection-container add-2-buttons"}>
              <h2 className='subheader'>Plot Duration</h2>
              <FormControl>
                <RadioGroup
                  aria-labelledby="plot dutation radio buttons"
                  value={this.state.duration}
                  onChange={(event) => {
                    selectedDate.duration = event.target.value;
                    this.setState({ units: (+selectedDate.duration === 10 ? 'minutes' : 'hours') });
                    this.setState({ duration: event.target.value }, () => {
                      this.props.holdNewCriteria(this.state);
                      this.saveDateTimeToLocalStorage();
                    });
                  }}
                >
                  <FormControlLabel value={15} control={<Radio color="default" size="small" />} label="15 minutes" />
                  <FormControlLabel value={1} control={<Radio color="default" size="small" />} label="1 hour" />
                  <FormControlLabel value={2} control={<Radio color="default" size="small" />} label="2 hours" />
                  <FormControlLabel value={4} control={<Radio color="default" size="small" />} label="4 hours" />
                  <FormControlLabel value={6} control={<Radio color="default" size="small" />} label="6 hours" />
                  <FormControlLabel value={8} control={<Radio color="default" size="small" />} label="8 hour" />
                  <FormControlLabel value={10} control={<Radio color="default" size="small" />} label="10 hours" />
                  <FormControlLabel value={12} control={<Radio color="default" size="small" />} label="12 hours" />
                </RadioGroup>
              </FormControl>
              {/* <Select
                                value={this.state.duration}
                                onChange={(event) => this.setState({ duration: event.target.value })}>
                                <MenuItem value={10}>10 min</MenuItem>
                                <MenuItem value={1}>1 hr</MenuItem>
                                <MenuItem value={2}>2 hrs</MenuItem>
                                <MenuItem value={4}>4 hrs</MenuItem>
                                <MenuItem value={6}>6 hrs</MenuItem>
                            </Select> */}
            </div>
            <div className='new-control-form-right-panel-buttons'>
              <button className='reset-button' onClick={() => {
                let obj = { showYear: 2015, year: 2015, month: 10, day: 16, time: '12:00' }
                selectedDate.date = new Date(Date.UTC(2015, 9, 16, 12, 0)); // Oct is month 9 (0-indexed)
                this.setState({ startTime: selectedDate.date }, () => { this.props.holdNewCriteria(this.state); });
                this.setState({ dateObj: obj }, () => {
                  this.createMonthsCalendar(true);
                });
                this.saveDateTimeToLocalStorage();
              }}>Reset</button>
              <button className='next-button' onClick={() => {
                this.props.nextButton();
              }}>Next <span class="rightarrow-form"></span></button>
            </div>
          </Grid>
        </Grid>
      </React.Fragment >
    );
  }
}

// ControlFormEventDatabase - Scientific paper event search drawer
class ControlFormEventDatabase extends Component {
  constructor(props) {
    super(props);
    this.triggerSearch = this.triggerSearch.bind(this);
    this.IncludeDates = this.importDatesToInclude();
    this.setSearchDateTime = this.setSearchDateTime.bind(this);
    const arrayorder = {};
    this.yearRange = new Date();
    this.minDateObj = { year: 2015, month: 9, day: 1 };
    this.maxDateObj = { year: this.yearRange.getFullYear(), month: this.yearRange.getMonth(), day: this.yearRange.getDate() };
    this.initialLoad = true;
    this.initialLoad = true;

    if (VARIABLES.options.idformat === 'long') {
      VARIABLES.categories
        .filter(variable => variable.full_id)
        .forEach(variable => {
          variable.id = variable.full_id;
        })
    };

    let savedData = null;
    try {
      const savedDataString = localStorage.getItem('savedVariablesData');
      if (savedDataString) {
        savedData = JSON.parse(savedDataString);
      }
    } catch (e) {
      console.warn('Failed to parse saved data in ControlFormEventDatabase constructor:', e);
    }

    const useSavedData = savedData && savedData.startTime && savedData.duration !== undefined;
    const initialDuration = useSavedData ? savedData.duration : (props.duration || selectedDate.duration || 2);

    if (useSavedData) {
      selectedDate.duration = savedData.duration;
    }

    const dateObjTime = useSavedData ?
      (selectedDate.date.getUTCHours() < 10 ? '0' : '') + selectedDate.date.getUTCHours() + ':' +
      (selectedDate.date.getUTCMinutes() < 10 ? '0' : '') + selectedDate.date.getUTCMinutes() :
      (selectedDate.date.getUTCHours() < 10 ? '0' : '') + selectedDate.date.getUTCHours() + ':' +
      (selectedDate.date.getUTCMinutes() < 30 ? '00' : '30');

    this.state = {
      duration: initialDuration,
      units: "hours",
      event: "none",
      startTime: new Date(Constants.DEFAULT_START_TIME),
      endTime: "none",
      context: 'landingpage',
      initialSearchQuery: "GSM",
      searchbox_label: props.searchbox_label || "Event Search:",
      searchQuery: props.searchQuery || props.initialSearchQuery || "",
      searchData: "none",
      sitl_present: null,
      dateObj: {
        showYear: selectedDate.date.getUTCFullYear(),
        year: selectedDate.date.getUTCFullYear(),
        month: selectedDate.date.getUTCMonth() + 1,
        day: selectedDate.date.getUTCDate(),
        time: dateObjTime
      },
    };

    if (props.defaults && !useSavedData) {
      for (let key in props.defaults) {
        if (this.state[key] !== null) {
          this.state[key] = props.defaults[key];
        }
        if (key === 'startTime') {
          selectedDate.date = new Date(props.defaults[key]);
          this.state.dateObj = {
            showYear: selectedDate.date.getUTCFullYear(),
            year: selectedDate.date.getUTCFullYear(),
            month: selectedDate.date.getUTCMonth() + 1,
            day: selectedDate.date.getUTCDate(),
            time: (selectedDate.date.getUTCHours() < 10 ? '0' : '') + selectedDate.date.getUTCHours() + ':' + (selectedDate.date.getUTCMinutes() < 30 ? '00' : '30')
          };
        }
      }

      if (this.state.duration > 6) {
        this.state.units = "minutes"
      }
      else {
        this.state.units = "hours"
      }
      this.state.context = 'resultspage';
      this.state.initialSearchQuery = props.initialSearchQuery || props.defaults.initialSearchQuery;
    }

    if (this.state.duration > 6) {
      this.state.units = "minutes"
    }
    else {
      this.state.units = "hours"
    }

    this.state.calendar = this.createMonthsCalendar(true);
  }

  triggerSearch(ev) {
    console.log("triggerSearch: " + this.state.searchQuery);
  };

  setSearchDateTime(value) {
    this.setState({
      searchDate: value
    })
    this.setClanderToDate(value);
  }

  importDatesToInclude() {
    const dates = [];
    if (Utils.areWeTestingWithJest()) {
      dates.push(new Date());
      return dates;
    }

    axios.get(`api/include_dates?file=on_backend`
    ).then(resp => {
      if (resp.data.error) {
        const { message } = resp.data;
        const redirect = <Redirect to={`/error/${message}`} />
        this.setState({ redirect });
        return;
      }

      const {
        results
      } = resp.data;
      results.forEach(thisdate => {
        dates.push(new Date(thisdate));
      });
      this.get_latest_date(dates);

    })
      .catch(error => {
        if (!Utils.areWeTestingWithJest()) {
          const message = "An unknown error downloading included dates. Using default set";
        }
        DEFAULT_INCLUDE_DATES.forEach(thisdate => {
          var thisDate = new Date(thisdate);
          var zd = this.calculate_zone(thisDate);
          thisDate.setHours(thisDate.getHours() + zd);

          dates.push(new Date(thisdate));
        });

      })
    return dates;
  }

  componentDidMount() {
    if (this.props.startTime) {
      this.setState({ startTime: this.props.startTime });
    }
    if (this.props.initialSearchQuery != null && this.props.initialSearchQuery != "") {
      this.setState({ searchQuery: this.props.initialSearchQuery });
    }
  }

  get_latest_date(dates) {
    var latest = DEFAULT_INCLUDE_DATES.slice(-1).toString();
    if (dates && dates.length > 1) {
      latest = dates.slice(-1).toString();
    }
    this.setState({ present: latest });
  }

  createMonthsCalendar(scrollToDate) {
    let leapYear = (this.state.dateObj.showYear % 4 === 0);
    let startDate = moment(`${this.state.dateObj.showYear}-01-01`, "YYYY-MM-DD");
    let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    let monthStartDay = days.indexOf(startDate.format('dddd'));
    let calendarObj = {
      'January': { 'daycount': 31, 'display': [], 'num': 1 },
      'February': { 'daycount': (leapYear === true ? 29 : 28), 'display': [], 'num': 2 },
      'March': { 'daycount': 31, 'display': [], 'num': 3 },
      'April': { 'daycount': 30, 'display': [], 'num': 4 },
      'May': { 'daycount': 31, 'display': [], 'num': 5 },
      'June': { 'daycount': 30, 'display': [], 'num': 6 },
      'July': { 'daycount': 31, 'display': [], 'num': 7 },
      'August': { 'daycount': 31, 'display': [], 'num': 8 },
      'September': { 'daycount': 30, 'display': [], 'num': 9 },
      'October': { 'daycount': 31, 'display': [], 'num': 10 },
      'November': { 'daycount': 30, 'display': [], 'num': 11 },
      'December': { 'daycount': 31, 'display': [], 'num': 12 }
    }
    for (let month in calendarObj) {
      let weekCount = 0;
      let weekHTML = [];
      for (let i = 0; (i < calendarObj[month]['daycount'] + monthStartDay) || !(weekCount === 0); i++) {
        let dayNumber = i + 1 - monthStartDay;
        if ((i < monthStartDay && monthStartDay > weekCount) || i >= calendarObj[month]['daycount'] + monthStartDay) {
          weekHTML.push(<div className='day blank'></div>);
          weekCount++;
        } else {
          let notInRange = ((this.maxDateObj.year <= this.state.dateObj.showYear)
            && (((this.maxDateObj.month === calendarObj[month]['num'])
              && (this.maxDateObj.day < dayNumber)) || this.maxDateObj.month < calendarObj[month]['num']))
            || ((this.minDateObj.year >= this.state.dateObj.showYear)
              && (((this.minDateObj.month === calendarObj[month]['num'])
                && (this.minDateObj.day > dayNumber)) || this.minDateObj.month > calendarObj[month]['num']));
          weekHTML.push(<button
            className={'day ' + (((this.state.dateObj.day === dayNumber) &&
              (calendarObj[month]['num'] === this.state.dateObj.month) &&
              (this.state.dateObj.showYear === this.state.dateObj.year)) ? 'slectedDay' : '')}
            onClick={() => {
              let obj = this.state.dateObj;
              obj.month = calendarObj[month]['num'];
              obj.day = dayNumber;
              obj.year = this.state.dateObj.showYear;
              let time = this.state.dateObj.time.split(':');
              selectedDate.date = new Date(Date.UTC(obj.year, obj.month - 1, obj.day, time[0], time[1]));
              this.setState({ startTime: selectedDate.date }, () => { this.props.holdNewCriteria(this.state); });
              this.setState({ dateObj: obj }, () => { this.createMonthsCalendar(false) });
              this.saveDateTimeToLocalStorage();
            }}
            disabled={notInRange}
          >
            {dayNumber}
          </button>);
          weekCount++;
        }
        if (weekCount === 7) {
          calendarObj[month]['display'].push(<div className='week'>{weekHTML}</div>);
          weekCount = 0;
          weekHTML = [];
        }
      }
      monthStartDay = (monthStartDay + calendarObj[month]['daycount']) % 7;
    }
    calendarObj.days = (<div className='week'><div className='day'>S</div>
      <div className='day letter'>M</div>
      <div className='day letter'>T</div>
      <div className='day letter'>W</div>
      <div className='day letter'>T</div>
      <div className='day letter'>F</div>
      <div className='day letter'>S</div></div>);
    this.setState({ calendar: calendarObj }, () => {
      if (this.state.dateObj.showYear === this.state.dateObj.year && scrollToDate) {
        this.scrollToSelected()
      }
    });
    return calendarObj;
  }

  createTimeDisplay() {
    let timeDisplay = []
    for (let x = 0; x < 24; x++) {
      if (x < 10) {
        timeDisplay.push(<button
          className={'timeDisplay ' + (this.state.dateObj.time === '0' + x + ':00' ? 'selectedTime' : '')}
          onClick={() => {
            let obj = this.state.dateObj;
            obj.time = '0' + x + ':00';
            selectedDate.date = new Date(Date.UTC(obj.year, obj.month - 1, obj.day, '0' + x, '00'));
            this.setState({ startTime: selectedDate.date }, () => { this.props.holdNewCriteria(this.state); });
            this.setState({ dateObj: obj });
            this.saveDateTimeToLocalStorage();
          }}
        >{'0' + x + ':00'}</button>);
        timeDisplay.push(<button
          className={'timeDisplay ' + (this.state.dateObj.time === '0' + x + ':30' ? 'selectedTime' : '')}
          onClick={() => {
            let obj = this.state.dateObj;
            obj.time = '0' + x + ':30';
            selectedDate.date = new Date(Date.UTC(obj.year, obj.month - 1, obj.day, '0' + x, '30'));
            this.setState({ startTime: selectedDate.date }, () => { this.props.holdNewCriteria(this.state); });
            this.setState({ dateObj: obj });
            this.saveDateTimeToLocalStorage();
          }}
        >{'0' + x + ':30'}</button>);
      } else {
        timeDisplay.push(<button
          className={'timeDisplay ' + (this.state.dateObj.time === x + ':00' ? 'selectedTime' : '')}
          onClick={() => {
            let obj = this.state.dateObj;
            obj.time = x + ':00';
            selectedDate.date = new Date(Date.UTC(obj.year, obj.month - 1, obj.day, x, '00'));
            this.setState({ startTime: selectedDate.date }, () => { this.props.holdNewCriteria(this.state); });
            this.setState({ dateObj: obj });
            this.saveDateTimeToLocalStorage();
          }}>{x + ':00'}</button>);
        timeDisplay.push(<button
          className={'timeDisplay ' + (this.state.dateObj.time === x + ':30' ? 'selectedTime' : '')}
          onClick={() => {
            let obj = this.state.dateObj;
            obj.time = x + ':30';
            selectedDate.date = new Date(Date.UTC(obj.year, obj.month - 1, obj.day, x, '30'));
            this.setState({ startTime: selectedDate.date }, () => { this.props.holdNewCriteria(this.state); });
            this.setState({ dateObj: obj });
            this.saveDateTimeToLocalStorage();
          }}
        >{x + ':30'}</button>);
      }
    }
    return timeDisplay;
  }

  scrollToSelected(attempt) {
    this.initialLoad = false;
    attempt = attempt || 1;
    let scrollToDay = document.getElementsByClassName("slectedDay")[0];
    if (scrollToDay) {
      scrollToDay.scrollIntoView({ behavior: "smooth", block: "center" });
    } else {
      if (attempt < 10) {
        setTimeout(() => {
          this.scrollToSelected(attempt + 1);
        }, 100);
      }
    }
    let scrollToTime = document.getElementsByClassName("selectedTime")[0];
    if (scrollToTime) {
      setTimeout(() => {
        scrollToTime.scrollIntoView({ behavior: "smooth", block: "center" });
      }, 700);
    } else {
      if (attempt < 10) {
        setTimeout(() => {
          this.scrollToSelected(attempt + 1);
        }, 100);
      }
    }
    return;
  }

  calculate_zone(eventdate) {
    if (eventdate) {
      var myLocal = eventdate.getHours();
      var myUtc = eventdate.getUTCHours();
      if (myUtc <= 4) {
        myUtc += 24;
      }
      return myLocal - myUtc;
    }
    return 0
  }

  setClanderToDate(newDateInput, exactTime) {
    let newDataObj = this.state.dateObj;
    if (exactTime) {
      selectedDate.date = new Date(newDateInput);
    } else {
      selectedDate.date = new Date(moment(newDateInput).add(-(selectedDate.duration / 2), this.state.units));
    }
    newDataObj.year = selectedDate.date.getUTCFullYear();
    newDataObj.showYear = selectedDate.date.getUTCFullYear();
    newDataObj.month = selectedDate.date.getUTCMonth() + 1;
    newDataObj.day = selectedDate.date.getUTCDate();
    newDataObj.time = (selectedDate.date.getUTCHours() < 10 ? '0' : '') + selectedDate.date.getUTCHours() + ':' + ((selectedDate.date.getUTCMinutes() < 15 || selectedDate.date.getUTCMinutes() > 45) ? '00' : '30');
    let time = newDataObj.time.split(':');
    selectedDate.date = new Date(Date.UTC(newDataObj.year, newDataObj.month - 1, newDataObj.day, time[0], time[1]));
    this.setState({ dateObj: newDataObj }, () => { this.createMonthsCalendar(true); });
    this.setState({ startTime: selectedDate.date }, () => { this.props.holdNewCriteria(this.state); });
    this.saveDateTimeToLocalStorage();
    return;
  }

  saveDateTimeToLocalStorage() {
    try {
      const savedDataString = localStorage.getItem('savedVariablesData');
      const savedData = savedDataString ? JSON.parse(savedDataString) : {};
      savedData.startTime = selectedDate.date.toISOString();
      savedData.duration = this.state.duration;
      localStorage.setItem('savedVariablesData', JSON.stringify(savedData));
      console.log('Saved date/time to localStorage from EventDatabase:', savedData.startTime, 'duration:', savedData.duration);
    } catch (e) {
      console.warn('Failed to save date/time to localStorage:', e);
    }
  }

  render() {
    // Build list of elements for the events picker
    const eventMenuItems = [];
    EVENTS.events.forEach(eventObj => {
      const menuItem = (
        <ListItemButton
          className={((new Date(eventObj.displayLabel) > selectedDate.date && new Date(eventObj.displayLabel) < moment(selectedDate.date).add(selectedDate.duration, this.state.units)) ? 'slectedTime' : '') + ' featuredEventButton'}
          value={eventObj.key}
          key={eventObj.key}
          onClick={() => {
            this.setState({ event: eventObj.key });
            this.setClanderToDate(eventObj.displayLabel);
          }
          }>
          <ListItemText 
            className='featuredListText'
            primary={`${eventObj.key} - ${eventObj.displayLabel}`}
            secondary={eventObj.description}
          />
        </ListItemButton>
      );
      eventMenuItems.push(menuItem);
    });

    let timeDisplay = this.createTimeDisplay();
    selectedDate.displayTime = (this.state.dateObj.year + '-' +
      (this.state.dateObj.month < 10 ? '0' : '') + this.state.dateObj.month + '-' +
      (this.state.dateObj.day < 10 ? '0' : '') + this.state.dateObj.day + ' ' + this.state.dateObj.time);
    
    let endDate = new Date(moment(selectedDate.date).add((selectedDate.duration), this.state.units));
    let endTime = (endDate.getUTCHours() < 10 ? '0' : '') + endDate.getUTCHours() + ':' + (endDate.getUTCMinutes() < 10 ? '0' : '') + endDate.getUTCMinutes();
    selectedDate.displayEndTime = (endDate.getUTCFullYear() + '-' +
      ((endDate.getUTCMonth() + 1) < 10 ? '0' : '') + (endDate.getUTCMonth() + 1) + '-' +
      (endDate.getUTCDate() < 10 ? '0' : '') + endDate.getUTCDate() + ' ' + endTime);
    
    if (this.initialLoad) {
      this.scrollToSelected();
    }

    return (
      <React.Fragment>
        <div className='drawer-header'>
          <span className={"grid-title"} onClick={() => {
            let obj = this.state.dateObj;
            obj.showYear = this.state.dateObj.year;
            this.setState({ dateObj: obj }, () => {
              this.createMonthsCalendar(true)
            });
          }}>
            <h1>Event Database</h1>
            <span style={{
              letterSpacing: '1px',
            }}>Selected time-span: </span>
            <span>{selectedDate.displayTime}</span>
            <span className='to-spacing'>to</span>
            <span className='to-spacing'>{selectedDate.displayEndTime}</span>
          </span>
          <button aria-label="Close event database drawer"
            className='close-drawer-button'
            onClick={() => this.props.closeDrawer()}></button>
        </div>
        <Grid
          className='drawer-grid'
          container
          columnSpacing={3}
          style={{
            marginLeft: '16px',
            marginRight: '30px',
            marginTop: '25px',
            width: 'auto',
            height: '100%'
          }}>

          <Grid item xs={12} sm={12} md={3} lg={2.7} xl={2.7} >
            <div className={"item-border item-container"}>
              <h2 className='subheader'>Date / Time</h2>
              <div className='yearPicker'>
                <button
                  className='yearNav leftarrow-year'
                  onClick={() => {
                    let obj = this.state.dateObj;
                    obj.showYear = this.state.dateObj.showYear - 1;
                    this.setState({ dateObj: obj }, () => {
                      this.createMonthsCalendar(true)
                    });
                  }}
                  disabled={this.minDateObj.year >= this.state.dateObj.showYear}
                  aria-label="move selected left"
                >
                </button>
                <h3 className='yearTitle'>{this.state.dateObj.showYear}</h3>
                <button
                  className='yearNav rightarrow-year'
                  onClick={() => {
                    let obj = this.state.dateObj;
                    obj.showYear = this.state.dateObj.showYear + 1;
                    this.setState({ dateObj: obj }, () => {
                      this.createMonthsCalendar(true)
                    });
                  }}
                  disabled={this.maxDateObj.year <= this.state.dateObj.showYear}
                  aria-label="move selected right"
                >
                </button>
              </div>
              <hr class="divider"></hr>
              <div className='calendarAlignment'>
                <div className='dayPicker'>
                  <h3 className='monthTitle'>January</h3>
                  {this.state.calendar.days}
                  {this.state.calendar.January.display}
                  <h3 className='monthTitle'>February</h3>
                  {this.state.calendar.days}
                  {this.state.calendar.February.display}
                  <h3 className='monthTitle'>March</h3>
                  {this.state.calendar.days}
                  {this.state.calendar.March.display}
                  <h3 className='monthTitle'>April</h3>
                  {this.state.calendar.days}
                  {this.state.calendar.April.display}
                  <h3 className='monthTitle'>May</h3>
                  {this.state.calendar.days}
                  {this.state.calendar.May.display}
                  <h3 className='monthTitle'>June</h3>
                  {this.state.calendar.days}
                  {this.state.calendar.June.display}
                  <h3 className='monthTitle'>July</h3>
                  {this.state.calendar.days}
                  {this.state.calendar.July.display}
                  <h3 className='monthTitle'>August</h3>
                  {this.state.calendar.days}
                  {this.state.calendar.August.display}
                  <h3 className='monthTitle'>September</h3>
                  {this.state.calendar.days}
                  {this.state.calendar.September.display}
                  <h3 className='monthTitle'>October</h3>
                  {this.state.calendar.days}
                  {this.state.calendar.October.display}
                  <h3 className='monthTitle'>November</h3>
                  {this.state.calendar.days}
                  {this.state.calendar.November.display}
                  <h3 className='monthTitle'>December</h3>
                  {this.state.calendar.days}
                  {this.state.calendar.December.display}
                </div>
                <div className='timePicker'>
                  {timeDisplay}
                </div>
              </div>
            </div>
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={7.3} xl={7.3} >
            <div className={"item-border item-container event-database-search"}>
              <h2 className='subheader'>Scientific Paper Event Search</h2>
              <SciencePaperSearch
                onTimestampClick={(date) => {
                  console.log('Timestamp clicked in Event Database, setting date to:', date);
                  this.setClanderToDate(date, true);
                }}
              />
            </div>
          </Grid>

          <Grid item xs={12} sm={12} md={3} lg={2} xl={2} >
            <div className={"item-border item-container selection-container add-2-buttons"}>
              <h2 className='subheader'>Plot Duration</h2>
              <FormControl>
                <RadioGroup
                  aria-labelledby="plot duration radio buttons"
                  value={this.state.duration}
                  onChange={(event) => {
                    selectedDate.duration = event.target.value;
                    this.setState({ units: (+selectedDate.duration === 10 ? 'minutes' : 'hours') });
                    this.setState({ duration: event.target.value }, () => {
                      this.props.holdNewCriteria(this.state);
                      this.saveDateTimeToLocalStorage();
                    });
                  }}
                >
                  <FormControlLabel value={10} control={<Radio color="default" size="small" />} label="10 minutes" />
                  <FormControlLabel value={1} control={<Radio color="default" size="small" />} label="1 hour" />
                  <FormControlLabel value={2} control={<Radio color="default" size="small" />} label="2 hours" />
                  <FormControlLabel value={4} control={<Radio color="default" size="small" />} label="4 hours" />
                  <FormControlLabel value={6} control={<Radio color="default" size="small" />} label="6 hours" />
                </RadioGroup>
              </FormControl>
            </div>
            <button className='reset-button' onClick={() => {
              let obj = { showYear: 2015, year: 2015, month: 10, day: 16, time: '12:00' }
              selectedDate.date = new Date(Date.UTC(2015, 9, 16, 12, 0));
              this.setState({ startTime: selectedDate.date }, () => { this.props.holdNewCriteria(this.state); });
              this.setState({ dateObj: obj }, () => {
                this.createMonthsCalendar(true);
              });
              this.saveDateTimeToLocalStorage();
            }}>Reset</button>
            <button className='next-button' onClick={() => {
              this.props.nextButton();
            }}>Next <span class="rightarrow-form"></span></button>
          </Grid>

        </Grid>
      </React.Fragment >
    );
  }
}

export {
  ControlFormDateTime,
  ControlFormNewVariables,
  ControlFormEventDatabase,
}
